(function () {
  'use strict';

  if (window.MRAppleProductBootstrapped) {
    if (window.MRAppleProductInit) window.MRAppleProductInit(document);
    return;
  }
  window.MRAppleProductBootstrapped = true;

  var SELECTORS = {
    section: '.mr-apple-product[data-section-id]',
    stickyHeaders: [
      'sticky-header',
      '.shopify-section-header-sticky',
      '.shopify-section-header-hidden',
      '#shopify-section-header',
      'header[role="banner"]',
      '.header-wrapper'
    ]
  };
  var CHOICE_COLLAPSE_LIMIT = 9;
  var MOBILE_MAX_WIDTH = 999;

  var DEFAULT_CONFIG = {
    template: 'basket_apple_v1',
    version: '1.0.0',
    nameMaxLength: 15,
    maxIcons: 3,
    maxYarnColors: 3,
    yarnColorMode: 'ordered',
    nameFonts: [],
    requiredSteps: null,
    yarnColorGroup: 'soft_basket',
    iconGroup: 'basket_icons',
    hiddenSteps: [],
    preview: {
      defaultCompare: 58,
      sizes: {}
    },
    options: {
      basketSizes: []
    },
    groups: {
      yarnColors: {},
      icons: {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('quick-view:open', function () {
    window.setTimeout(function () {
      initAll(document);
    }, 0);
  });

  document.addEventListener('mamaraya:quick-view:loaded', function (event) {
    window.setTimeout(function () {
      var container = event && event.detail && event.detail.container ? event.detail.container : document;
      initAll(container, { force: true });
    }, 0);
  });

  function initAll(context, options) {
    var root = context || document;
    var force = !!(options && options.force);
    var sections = [];

    if (root.matches && root.matches(SELECTORS.section)) {
      sections.push(root);
    }

    root.querySelectorAll(SELECTORS.section).forEach(function (section) {
      if (sections.indexOf(section) === -1) sections.push(section);
    });

    sections.forEach(function (section) {
      if (section.dataset.mrAppleInitialized === 'true') {
        if (!force || section.dataset.mrAppleReady === 'true') return;
        delete section.dataset.mrAppleInitialized;
      }

      try {
        if (initSection(section) === false) {
          delete section.dataset.mrAppleInitialized;
          delete section.dataset.mrAppleReady;
          return;
        }

        section.dataset.mrAppleInitialized = 'true';
        section.dataset.mrAppleReady = 'true';
      } catch (error) {
        delete section.dataset.mrAppleInitialized;
        delete section.dataset.mrAppleReady;
        console.warn('[MR Apple Product] Initialization failed:', error);
      }
    });
  }

  window.MRAppleProductInit = initAll;

  function initSection(section) {
    var sectionId = section.dataset.sectionId;
    if (!sectionId) return false;

    var rawProductData = readJson('MRAppleProductData-' + sectionId);
    var rawConfig = expandStoredProductConfig(readJson('MRAppleConfig-' + sectionId));
    if (!rawProductData || !rawConfig) return false;

    var productData = normalizeProductData(rawProductData);
    var config = normalizeConfig(rawConfig, productData);
    var elements = collectElements(section);
    var layerEditingEnabled = isLayerEditingEnabled(elements);
    config.nameMaxLength = clamp(
      positiveInteger(section.dataset.mrNameMaxLength, config.nameMaxLength),
      1,
      30
    );
    injectNameFonts(config, productData, sectionId);

    var initialFonts = getNameFonts(config, productData);

    var state = {
      sizeId: '',
      variantId: '',
      previewVariantId: '',
      selectedOptions: {},
      optionLabel: '',
      name: '',
      noName: false,
      fontId: initialFonts.length ? initialFonts[0].id : '',
      yarnId: '',
      yarnIds: [],
      icons: [],
      iconSlotAssignments: {},
      activated: {
        size: false,
        options: {},
        name: false,
        yarn: false,
        icons: false
      },
      compare: numberOr(config.preview.defaultCompare, 58),
      layerPositions: {},
      selectedLayer: layerEditingEnabled && !isMobileInteractionV2Active(elements) ? { type: 'name', id: null } : null,
      layerEditingEnabled: layerEditingEnabled,
      hiddenSteps: config.hiddenSteps || [],
      frontOrder: getFrontStepOrder(config, productData),
      unlockedSteps: {},
      reviewUnlocked: false,
      isDraggingLayer: false,
      isDraggingCompare: false,
      isSubmitting: false,
      configId: createConfigId(productData.productHandle),
      cartBundleId: ''
    };

    renderProductOptionCards(elements, productData, config, state);
    renderFontOptions(elements, productData, config, state);
    renderYarnOptions(elements, config, state);
    renderIconOptions(elements, config, state);
    bindEvents(elements, productData, config, state);
    bindLayerDragging(elements, config, state);
    bindCompareDragging(elements, state);
    bindMediaToggle(elements);
    bindMobilePreview(elements);
    bindProductMediaGallery(elements);
    bindStandardProductGallery(elements);
    setMediaMode(elements, elements.previewCard && elements.previewCard.classList.contains('is-product-media-mode'));
    setupHeaderOffsetSync(section);

    updateAll(elements, productData, config, state);

    return true;
  }

  function collectElements(section) {
    return {
      section: section,
      previewCard: section.querySelector('.mr-apple-product__preview-card'),
      previewColumn: section.querySelector('.mr-apple-product__preview-column'),
      previewBoard: section.querySelector('[data-mr-preview-board]'),
      mediaToggle: section.querySelector('[data-mr-media-toggle]'),
      mediaToggleLabel: section.querySelector('[data-mr-media-toggle-label]'),
      mobileMediaToggle: section.querySelector('[data-mr-mobile-media-toggle]'),
      mobileMediaToggleLabel: section.querySelector('[data-mr-mobile-media-toggle-label]'),
      mobilePreviewOpen: section.querySelector('[data-mr-mobile-preview-open]'),
      mobilePreviewClose: section.querySelector('[data-mr-mobile-preview-close]'),
      mobilePreviewCloses: Array.from(section.querySelectorAll('[data-mr-mobile-preview-close]')),
      mobilePreviewCollapse: section.querySelector('[data-mr-mobile-preview-collapse]'),
      mobilePreviewFloat: section.querySelector('[data-mr-mobile-preview-float]'),
      mobilePreviewMiniContent: section.querySelector('[data-mr-mobile-preview-mini-content]'),
      productMediaGallery: section.querySelector('[data-mr-product-media-gallery]'),
      productMediaMain: section.querySelector('[data-mr-product-media-main]'),
      productMediaSlides: Array.from(section.querySelectorAll('[data-mr-product-media-slide]')),
      productMediaThumbs: Array.from(section.querySelectorAll('[data-mr-product-media-thumb]')),
      productMediaPrev: section.querySelector('[data-mr-product-media-prev]'),
      productMediaNext: section.querySelector('[data-mr-product-media-next]'),
      standardMediaMain: section.querySelector('[data-mr-standard-media-main]'),
      standardMediaThumbs: Array.from(section.querySelectorAll('[data-mr-standard-thumb]')),
      standardMediaPrev: section.querySelector('[data-mr-standard-prev]'),
      standardMediaNext: section.querySelector('[data-mr-standard-next]'),
      realImage: section.querySelector('[data-mr-real-image]'),
      cleanImage: section.querySelector('[data-mr-clean-image]'),
      compositeClip: section.querySelector('[data-mr-composite-clip]'),
      compositeStage: section.querySelector('[data-mr-composite-stage]'),
      compareHandle: section.querySelector('[data-mr-compare-handle]'),
      resetLayouts: Array.from(section.querySelectorAll('[data-mr-reset-layout]')),
      nameLayer: section.querySelector('[data-mr-name-layer]'),
      linkedNameLayers: section.querySelector('[data-mr-linked-name-layers]'),
      iconLayers: section.querySelector('[data-mr-icon-layers]'),
      linkedIconLayers: section.querySelector('[data-mr-linked-icon-layers]'),
      optionCardAnchor: section.querySelector('[data-mr-option-card-anchor]'),
      optionCardsAfter: section.querySelector('[data-mr-option-cards-after]'),
      stepsBottom: section.querySelector('[data-mr-steps-bottom]'),
      yarnOptions: section.querySelector('[data-mr-yarn-options]'),
      iconOptions: section.querySelector('[data-mr-icon-options]'),
      iconLimit: section.querySelector('[data-mr-icon-limit]'),
      iconTitleText: section.querySelector('[data-mr-icon-title-text]'),
      reviewStage: section.querySelector('[data-mr-review-stage]'),
      nameInput: section.querySelector('[data-mr-name-input]'),
      noNameInput: section.querySelector('[data-mr-no-name]'),
      fontField: section.querySelector('[data-mr-font-field]'),
      fontOptions: section.querySelector('[data-mr-font-options]'),
      nameCount: section.querySelector('[data-mr-name-count]'),
      nameError: section.querySelector('[data-mr-name-error]'),
      prices: Array.from(section.querySelectorAll('[data-mr-price]')),
      comparePrices: Array.from(section.querySelectorAll('[data-mr-compare-price]')),
      form: section.querySelector('[data-mr-product-form]'),
      variantInput: section.querySelector('[data-mr-variant-id]'),
      quantityInput: section.querySelector('[data-mr-quantity]'),
      propertySize: section.querySelector('[data-mr-property-size]'),
      propertyName: section.querySelector('[data-mr-property-name]'),
      propertyFont: section.querySelector('[data-mr-property-font]'),
      propertyYarn: section.querySelector('[data-mr-property-yarn]'),
      propertyIcons: section.querySelector('[data-mr-property-icons]'),
      propertyNamePosition: section.querySelector('[data-mr-property-name-position]'),
      propertyIconPositions: section.querySelector('[data-mr-property-icon-positions]'),
      propertyTemplate: section.querySelector('[data-mr-property-template]'),
      propertyProductionCode: section.querySelector('[data-mr-property-production-code]'),
      propertyConfigId: section.querySelector('[data-mr-property-config-id]'),
      propertyLayoutJson: section.querySelector('[data-mr-property-layout-json]'),
      reviewSizeLabel: section.querySelector('[data-mr-review-size-label]'),
      reviewSize: section.querySelector('[data-mr-review-size]'),
      reviewName: section.querySelector('[data-mr-review-name]'),
      reviewYarn: section.querySelector('[data-mr-review-yarn]'),
      reviewIcons: section.querySelector('[data-mr-review-icons]'),
      reviewLayout: section.querySelector('[data-mr-review-layout]'),
      reviewTotal: section.querySelector('[data-mr-review-total]'),
      confirmPreview: section.querySelector('[data-mr-confirm-preview]'),
      confirmError: section.querySelector('[data-mr-confirm-error]'),
      addButton: section.querySelector('[data-mr-add-button]'),
      message: section.querySelector('[data-mr-message]')
    };
  }

  function bindEvents(elements, productData, config, state) {
    if (elements.nameInput) {
      elements.nameInput.maxLength = config.nameMaxLength;
      elements.nameInput.addEventListener('input', function () {
        state.name = cleanName(elements.nameInput.value, config.nameMaxLength);
        elements.nameInput.value = state.name;
        state.activated.name = state.noName || state.name.trim().length > 0;
        if (elements.nameError) elements.nameError.hidden = true;
        setMediaMode(elements, false);
        updateAll(elements, productData, config, state);
      });
    }

    if (elements.noNameInput) {
      elements.noNameInput.addEventListener('change', function () {
        state.noName = elements.noNameInput.checked;
        state.activated.name = state.noName || state.name.trim().length > 0;
        if (state.noName && state.selectedLayer && state.selectedLayer.type === 'name') {
          state.selectedLayer = null;
        }
        if (elements.nameError) elements.nameError.hidden = true;
        setMediaMode(elements, false);
        updateAll(elements, productData, config, state);
      });
    }

    (elements.resetLayouts || []).forEach(function (resetLayout) {
      resetLayout.addEventListener('click', function () {
        resetLayerPositions(config, state);
        updateAll(elements, productData, config, state);
      });
    });

    if (elements.confirmPreview) {
      elements.confirmPreview.addEventListener('change', function () {
        if (elements.confirmError) elements.confirmError.hidden = true;
        updateAddButton(elements, productData, config, state);
      });
    }

    if (elements.form) {
      elements.form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitForm(elements, productData, config, state);
      });
    }

  }

  function renderProductOptionCards(elements, productData, config, state) {
    var options = getSelectableProductOptions(productData, config);
    var anchor = elements.optionCardAnchor;
    if (!anchor || !anchor.parentNode) return;

    var optionColumn = elements.section.querySelector('[data-mr-option-column]');
    if (optionColumn) delete optionColumn.dataset.mrStepOrderApplied;

    elements.section.querySelectorAll('[data-mr-product-option-card]').forEach(function (card) {
      card.remove();
    });

    state.activated.options = {};
    state.activated.size = !options.length;
    if (!options.length) {
      if (elements.optionCardsAfter) elements.optionCardsAfter.hidden = true;
      return;
    }
    if (elements.optionCardsAfter) elements.optionCardsAfter.hidden = false;

    var sizeChartOptionNames = getSizeChartTargetOptionNames(elements, options);
    options.forEach(function (option) {
      var cardKey = getOptionCardKey(option.name);
      var card = document.createElement('section');
      card.className = 'mr-apple-product__config-card is-locked';
      card.dataset.mrCard = cardKey;
      card.dataset.mrProductOptionCard = option.name;
      card.setAttribute('aria-disabled', 'true');

      var head = document.createElement('div');
      head.className = 'mr-apple-product__card-head';
      var stepLabel = document.createElement('p');
      stepLabel.className = 'mr-apple-product__step-label';
      stepLabel.textContent = 'Step';
      var title = document.createElement('h2');
      title.className = 'mr-apple-product__card-title';
      title.textContent = 'Choose ' + option.name + '.';
      title.appendChild(createRequiredMarker());
      var subtitle = document.createElement('p');
      subtitle.className = 'mr-apple-product__card-subtitle';
      subtitle.textContent = 'This selection updates the product variant and preview.';
      head.appendChild(stepLabel);
      head.appendChild(title);
      head.appendChild(subtitle);
      var sizeChartButton = createSizeChartButton(elements, option.name, sizeChartOptionNames);
      if (sizeChartButton) {
        head.classList.add('has-size-chart');
        head.appendChild(sizeChartButton);
      }

      var grid = document.createElement('div');
      grid.className = 'mr-apple-product__choice-grid mr-apple-product__choice-grid--size';
      grid.dataset.mrOptionValues = option.name;

      option.values.forEach(function (value, index) {
        var valueBadge = getOptionValueBadge(config, option.name, value);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mr-apple-product__choice';
        if (valueBadge) {
          button.classList.add('has-value-badge');
        }
        if (index >= CHOICE_COLLAPSE_LIMIT) button.classList.add('is-extra-choice');
        button.dataset.mrProductOption = option.name;
        button.dataset.mrProductValue = value;
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-disabled', 'true');

        var label = document.createElement('span');
        label.className = 'mr-apple-product__choice-main';
        label.textContent = getOptionValueDisplayLabel(value, valueBadge);
        button.appendChild(label);
        if (valueBadge) {
          var badge = document.createElement('span');
          badge.className = 'mr-apple-product__value-badge mr-apple-product__value-badge--' + valueBadge.type.replace(/_/g, '-');
          badge.setAttribute('aria-hidden', 'true');
          var badgeIcon = createOptionValueBadgeIcon(valueBadge.type);
          badgeIcon.classList.add('mr-apple-product__value-badge-icon');
          badge.appendChild(badgeIcon);
          var badgeLabel = document.createElement('span');
          badgeLabel.className = 'mr-apple-product__value-badge-label';
          badgeLabel.textContent = valueBadge.label;
          badge.appendChild(badgeLabel);
          badge.appendChild(createFivePointStarSvg('mr-apple-product__value-badge-star'));
          button.appendChild(badge);
          button.setAttribute('aria-label', getOptionValueDisplayLabel(value, valueBadge) + ', ' + valueBadge.label);
        }
        button.addEventListener('click', function () {
          if (card.classList.contains('is-locked') || button.getAttribute('aria-disabled') === 'true') return;
          state.selectedOptions[option.name] = value;
          if (isFreeStepNavigation(elements)) {
            reconcileFreeOptionSelections(productData, state, option.name);
          } else {
            reconcileOptionSelectionsAfter(productData, state, cardKey);
          }
          syncSelectedVariantState(productData, config, state);
          state.activated.name = state.name.trim().length > 0;
          resetLayerPositions(config, state);
          hideMessage(elements);
          setMediaMode(elements, false);
          updateAll(elements, productData, config, state);
        });
        grid.appendChild(button);
      });

      addShowMoreButton(grid, option.values.length);
      var lockNote = document.createElement('p');
      lockNote.className = 'mr-apple-product__lock-note';
      lockNote.textContent = 'Complete the previous step first.';
      card.appendChild(head);
      card.appendChild(grid);
      card.appendChild(lockNote);
      anchor.parentNode.insertBefore(card, anchor);
    });

    state.frontOrder = getFrontStepOrder(config, productData);
    syncSelectedVariantState(productData, config, state);
  }

  function renderFontOptions(elements, productData, config, state) {
    if (!elements.fontOptions) return;
    var fonts = getNameFonts(config, productData);
    elements.fontOptions.innerHTML = '';
    if (!fonts.length) {
      if (elements.fontField) elements.fontField.hidden = true;
      state.fontId = '';
      return;
    }

    if (!fonts.some(function (font) { return font.id === state.fontId; })) {
      state.fontId = fonts[0].id;
    }
    if (elements.fontField) elements.fontField.hidden = fonts.length <= 1;

    fonts.forEach(function (font) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mr-apple-product__choice mr-apple-product__font-choice';
      button.dataset.mrFontId = font.id;
      button.setAttribute('aria-pressed', 'false');

      var preview = document.createElement('span');
      preview.className = 'mr-apple-product__font-preview';
      preview.textContent = state.name.trim() || 'Augustine';
      if (font.family) preview.style.fontFamily = font.family;

      var label = document.createElement('span');
      label.className = 'mr-apple-product__choice-meta';
      label.textContent = font.label || font.id;
      button.appendChild(preview);
      button.appendChild(label);
      button.addEventListener('click', function () {
        state.fontId = font.id;
        updateAll(elements, productData, config, state);
      });
      elements.fontOptions.appendChild(button);
    });
  }

  function renderYarnOptions(elements, config, state) {
    var yarnColors = getYarnColors(config);
    var yarnCard = elements.section.querySelector('[data-mr-card="yarn"]');
    elements.yarnOptions.innerHTML = '';

    if (!yarnColors.length) {
      state.activated.yarn = true;
      if (yarnCard) yarnCard.hidden = true;
      return;
    }
    if (yarnCard) yarnCard.hidden = false;

    yarnColors.forEach(function (color, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mr-apple-product__choice';
      if (index >= CHOICE_COLLAPSE_LIMIT) button.classList.add('is-extra-choice');
      button.dataset.mrYarnId = color.id;
      button.setAttribute('aria-pressed', 'false');

      var swatches = document.createElement('span');
      swatches.className = 'mr-apple-product__swatches';
      getColorList(color).forEach(function (item) {
        var dot = document.createElement('span');
        dot.className = 'mr-apple-product__swatch';
        dot.style.background = item;
        swatches.appendChild(dot);
      });

      var label = document.createElement('span');
      label.className = 'mr-apple-product__choice-main';
      label.textContent = color.label || color.id;

      if (color.image) {
        var yarnImage = document.createElement('span');
        yarnImage.className = 'mr-apple-product__yarn-image';
        var image = document.createElement('img');
        image.src = color.image;
        image.alt = color.label || color.id || 'Yarn color';
        image.loading = 'lazy';
        yarnImage.appendChild(image);
        button.appendChild(yarnImage);
      } else {
        button.appendChild(swatches);
      }
      button.appendChild(label);
      var orderBadge = document.createElement('span');
      orderBadge.className = 'mr-apple-product__choice-order';
      orderBadge.dataset.mrYarnOrder = '';
      orderBadge.hidden = true;
      button.appendChild(orderBadge);
      if (color.recommended === true) {
        button.classList.add('has-recommended');
        button.appendChild(createRecommendedStar());
      }

      button.addEventListener('click', function () {
        if (!canUseYarn(state)) return;
        if (!toggleYarnColor(elements, config, state, color.id)) return;
        hideMessage(elements);
        setMediaMode(elements, false);
        updateAll(elements, null, config, state);
      });

      elements.yarnOptions.appendChild(button);
    });

    addShowMoreButton(elements.yarnOptions, yarnColors.length);
  }

  function renderIconOptions(elements, config, state) {
    var icons = getIcons(config);
    var iconCard = elements.section.querySelector('[data-mr-card="icons"]');
    elements.iconOptions.innerHTML = '';

    if (!icons.length) {
      if (iconCard) iconCard.hidden = true;
      return;
    }
    if (iconCard) iconCard.hidden = false;

    icons.forEach(function (icon, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mr-apple-product__choice mr-apple-product__icon-choice';
      if (index >= CHOICE_COLLAPSE_LIMIT) button.classList.add('is-extra-choice');
      button.dataset.mrIconId = icon.id;
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', icon.label || icon.id || 'Icon option');

      var visual = document.createElement('span');
      visual.className = 'mr-apple-product__icon-visual';

      if (icon.image) {
        var img = document.createElement('img');
        img.src = icon.image;
        img.alt = icon.label || icon.id;
        img.loading = 'lazy';
        visual.appendChild(img);
      } else {
        visual.textContent = icon.emoji || '✽';
      }

      button.appendChild(visual);
      var price = getIconPriceCents(icon);
      if (price > 0) {
        var priceLabel = document.createElement('span');
        priceLabel.className = 'mr-apple-product__choice-meta';
        priceLabel.textContent = '+ ' + formatMoney(price, config.moneyFormat || '${{amount}}');
        button.appendChild(priceLabel);
      }
      if (icon.recommended === true) {
        button.classList.add('has-recommended');
        button.appendChild(createRecommendedStar());
      }

      button.addEventListener('click', function () {
        if (!canUseIcons(state)) return;
        toggleIcon(elements, config, state, icon.id);
        state.activated.icons = true;
        setMediaMode(elements, false);
        updateAll(elements, null, config, state);
      });

      elements.iconOptions.appendChild(button);
    });

    addShowMoreButton(elements.iconOptions, icons.length);
  }

  function updateAll(elements, productData, config, state) {
    var resolvedProductData = productData || normalizeProductData(readJson('MRAppleProductData-' + elements.section.dataset.sectionId));
    syncSelectedVariantState(resolvedProductData, config, state);
    var selectedSize = getSelectedSize(config, state);
    var selectedYarn = getSelectedYarn(config, state);
    var selectedIcons = getSelectedIcons(config, state);
    var selectedVariant = resolveSelectedVariant(resolvedProductData, config, state);

    if (elements.fontField) {
      elements.fontField.hidden = state.noName || getNameFonts(config, resolvedProductData).length <= 1;
    }

    ensureDefaultLayerPositions(config, state);
    updatePreviewImages(elements, config, state);
    updateCompare(elements, state);
    updateNameLayer(elements, config, state, selectedYarn);
    updateLinkedNameLayers(elements, config, state, selectedYarn);
    updateIconLayers(elements, config, state, selectedIcons);
    updateLinkedIconLayers(elements, config, state, selectedIcons);
    syncLayerSelection(elements, state);
    applyStepOrder(elements, config, resolvedProductData);
    applyStepVisibility(elements, config, state);
    syncFrontOrderFromRenderedCards(elements, state);
    updateCards(elements, resolvedProductData, config, state);
    updateOptionStates(elements, resolvedProductData, config, state);
    updateStepLabels(elements);
    updateSummary(elements, config, state, selectedSize, selectedYarn, selectedIcons, selectedVariant, resolvedProductData);
    updatePrice(elements, resolvedProductData, selectedVariant, selectedIcons);
    updateProperties(elements, resolvedProductData, config, state, selectedSize, selectedYarn, selectedIcons, selectedVariant);
    updateAddButton(elements, resolvedProductData, config, state);
  }

  function updatePreviewImages(elements, config, state) {
    var preview = getPreviewForState(config, state);

    setImage(elements.realImage, preview.realImage || '');
    setImage(elements.cleanImage, preview.cleanImage || '');
  }

  function updateCompare(elements, state) {
    var value = clamp(numberOr(state.compare, 58), 5, 95);
    state.compare = value;
    if (elements.previewBoard) {
      elements.previewBoard.style.setProperty('--mr-compare-width', value + '%');
    }
  }

  function updateNameLayer(elements, config, state, selectedYarn) {
    var layer = elements.nameLayer;
    if (!layer) return;

    layer.hidden = Boolean(state.noName);
    layer.style.display = state.noName ? 'none' : '';
    if (state.noName) {
      layer.classList.remove('is-selected', 'is-dragging');
      return;
    }

    var preview = getPreviewForState(config, state);
    var nameConfig = preview.name || {};
    var position = state.layerPositions.name || { x: numberOr(nameConfig.x, 50), y: numberOr(nameConfig.y, 42) };
    var displayName = state.name.trim() || 'Name';
    var colors = selectedYarn ? getColorList(selectedYarn) : ['#1d1d1f'];
    var selectedFont = getSelectedFont(config, state);
    var maxWidth = clamp(numberOr(
      nameConfig.maxWidth,
      numberOr(config.preview && config.preview.nameMaxWidth, 58)
    ), 1, 100);
    var maxHeight = optionalPositiveNumber(nameConfig.maxHeight);

    renderNameText(layer, displayName, colors);
    layer.classList.toggle('is-placeholder', !state.name.trim());
    layer.style.left = clamp(position.x, 0, 100) + '%';
    layer.style.top = clamp(position.y, 0, 100) + '%';
    layer.style.setProperty('--mr-layer-scale', numberOr(position.scale, 1));
    layer.style.setProperty('--mr-layer-rotation', numberOr(position.rotation, 0) + 'deg');
    layer.style.setProperty('--mr-name-color', makeGradientOrColor(colors));
    layer.classList.toggle('is-selected', state.selectedLayer && state.selectedLayer.type === 'name');
    layer.style.backgroundImage = '';
    layer.style.webkitBackgroundClip = '';
    layer.style.backgroundClip = '';
    layer.style.color = colors[0] || '#1d1d1f';
    layer.style.fontFamily = selectedFont && selectedFont.family
      ? selectedFont.family
      : 'var(--mr-name-font-family)';
    if (maxHeight) {
      fitNameLayerToBounds(elements, layer, displayName, maxWidth, maxHeight);
    } else {
      layer._mrApplyNameFit = null;
      layer.style.fontSize = numberOr(
        nameConfig.fontSize,
        numberOr(config.preview && config.preview.nameFontSize, 76)
      ) + 'px';
      layer.style.maxWidth = maxWidth + '%';
      layer.style.maxHeight = '';
      layer.style.minWidth = '';
    }
    if (elements.fontOptions) {
      elements.fontOptions.querySelectorAll('.mr-apple-product__font-preview').forEach(function (preview) {
        preview.textContent = displayName;
      });
    }
    appendTransformHandles(layer, 'name', null, state);
  }

  function fitNameLayerToBounds(elements, layer, displayName, maxWidth, maxHeight, maxFontSize) {
    var stage = elements.compositeStage || elements.previewBoard;
    if (!stage) return;

    var fitToken = [displayName, maxWidth, maxHeight, maxFontSize || '', layer.style.fontFamily].join('|');
    layer.dataset.mrNameFitToken = fitToken;
    layer.style.maxWidth = maxWidth + '%';
    layer.style.maxHeight = maxHeight + '%';
    layer.style.minWidth = '0';

    var applyFit = function () {
      if (!layer.isConnected || layer.dataset.mrNameFitToken !== fitToken) return;
      var stageRect = stage.getBoundingClientRect();
      if (!stageRect.width || !stageRect.height) return;

      var computed = window.getComputedStyle(layer);
      var canvas = fitNameLayerToBounds.canvas || (fitNameLayerToBounds.canvas = document.createElement('canvas'));
      var context = canvas.getContext('2d');
      if (!context) return;

      var testSize = 100;
      context.font = [computed.fontStyle, computed.fontWeight, testSize + 'px', computed.fontFamily].join(' ');
      var measuredWidth = Math.max(1, context.measureText(displayName).width);
      var strokeWidth = parseFloat(computed.webkitTextStrokeWidth || computed.textStrokeWidth || '0') || 0;
      var availableWidth = Math.max(1, stageRect.width * maxWidth / 100 - strokeWidth * 2);
      var availableHeight = Math.max(1, stageRect.height * maxHeight / 100 - strokeWidth * 2);
      var fittedSize = Math.max(1, Math.min(
        availableWidth * testSize / measuredWidth,
        availableHeight / 1.05,
        maxFontSize || Number.POSITIVE_INFINITY
      ));

      layer.style.fontSize = (Math.round(fittedSize * 100) / 100) + 'px';
    };

    layer._mrApplyNameFit = applyFit;
    applyFit();
    window.requestAnimationFrame(applyFit);

    if (!layer._mrNameFitObserver && window.ResizeObserver) {
      layer._mrNameFitObserver = new ResizeObserver(function () {
        if (typeof layer._mrApplyNameFit === 'function') layer._mrApplyNameFit();
      });
      layer._mrNameFitObserver.observe(stage);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(applyFit).catch(function () {});
    }
  }

  function updateLinkedNameLayers(elements, config, state, selectedYarn) {
    var container = elements.linkedNameLayers;
    if (!container) return;
    clearLinkedNameLayers(container);
    if (state.noName) return;

    var preview = getCurrentVariantPreview(config, state);
    var positions = preview && Array.isArray(preview.linkedNames) ? preview.linkedNames : [];
    if (!positions.length) return;

    var displayName = state.name.trim() || 'Name';
    var colors = selectedYarn ? getColorList(selectedYarn) : ['#1d1d1f'];
    var selectedFont = getSelectedFont(config, state);
    var fragment = document.createDocumentFragment();

    positions.forEach(function (position, index) {
      var layer = document.createElement('div');
      layer.className = 'mr-apple-product__layer mr-apple-product__name-layer mr-apple-product__linked-layer mr-apple-product__linked-name-layer';
      layer.dataset.mrLinkedNameId = position.id || ('linked-name-' + (index + 1));
      layer.setAttribute('aria-hidden', 'true');

      var maxWidth = clamp(numberOr(position.maxWidth, 58), 1, 100);
      var maxHeight = optionalPositiveNumber(position.maxHeight);
      var fontSize = positiveInteger(position.fontSize, 76);

      renderNameText(layer, displayName, colors);
      layer.classList.toggle('is-placeholder', !state.name.trim());
      layer.style.left = clamp(numberOr(position.x, 50), 0, 100) + '%';
      layer.style.top = clamp(numberOr(position.y, 42), 0, 100) + '%';
      layer.style.setProperty('--mr-layer-scale', 1);
      layer.style.setProperty('--mr-layer-rotation', '0deg');
      layer.style.setProperty('--mr-name-color', makeGradientOrColor(colors));
      layer.style.color = colors[0] || '#1d1d1f';
      layer.style.fontFamily = selectedFont && selectedFont.family
        ? selectedFont.family
        : 'var(--mr-name-font-family)';

      fragment.appendChild(layer);
      if (maxHeight) {
        fitNameLayerToBounds(elements, layer, displayName, maxWidth, maxHeight, fontSize);
      } else {
        layer.style.fontSize = fontSize + 'px';
        layer.style.maxWidth = maxWidth + '%';
      }
    });

    container.appendChild(fragment);
  }

  function clearLinkedNameLayers(container) {
    container.querySelectorAll('.mr-apple-product__linked-name-layer').forEach(function (layer) {
      if (layer._mrNameFitObserver) layer._mrNameFitObserver.disconnect();
    });
    container.innerHTML = '';
  }

  function updateIconLayers(elements, config, state, selectedIcons) {
    if (!elements.iconLayers) return;
    elements.iconLayers.innerHTML = '';

    selectedIcons.forEach(function (icon, index) {
      var slotIndex = getAssignedIconSlotIndex(state, icon.id, index);
      var pos = state.layerPositions.icons && state.layerPositions.icons[icon.id]
        ? state.layerPositions.icons[icon.id]
        : getDefaultIconPosition(config, state, slotIndex);

      var layer = document.createElement('div');
      layer.className = 'mr-apple-product__layer mr-apple-product__icon-layer';
      layer.dataset.mrLayer = 'icon';
      layer.dataset.mrIconId = icon.id;
      if (state.layerEditingEnabled) {
        layer.setAttribute('role', 'button');
        layer.setAttribute('tabindex', '0');
        layer.setAttribute('aria-label', 'Drag ' + (icon.label || icon.id) + ' icon layer');
      } else {
        layer.setAttribute('aria-hidden', 'true');
      }
      layer.style.left = clamp(pos.x, 0, 100) + '%';
      layer.style.top = clamp(pos.y, 0, 100) + '%';
      layer.style.setProperty('--mr-layer-size', numberOr(pos.size, 92) + 'px');
      layer.style.setProperty('--mr-layer-scale', numberOr(pos.scale, 1));
      layer.style.setProperty('--mr-layer-rotation', numberOr(pos.rotation, 0) + 'deg');
      layer.classList.toggle('is-selected', state.selectedLayer && state.selectedLayer.type === 'icon' && state.selectedLayer.id === icon.id);

      if (icon.image) {
        var img = document.createElement('img');
        img.src = icon.image;
        img.alt = icon.label || icon.id;
        layer.appendChild(img);
      } else {
        layer.textContent = icon.emoji || '✽';
      }

      appendTransformHandles(layer, 'icon', icon.id, state);
      elements.iconLayers.appendChild(layer);
    });
  }

  function updateLinkedIconLayers(elements, config, state, selectedIcons) {
    var container = elements.linkedIconLayers;
    if (!container) return;
    container.innerHTML = '';

    var preview = getCurrentVariantPreview(config, state);
    var positions = preview && Array.isArray(preview.linkedIcons) ? preview.linkedIcons : [];
    if (!positions.length) return;

    var fragment = document.createDocumentFragment();
    positions.forEach(function (position, index) {
      var icon = selectedIcons[position.sourceIndex];
      if (!icon) return;

      var layer = document.createElement('div');
      layer.className = 'mr-apple-product__layer mr-apple-product__icon-layer mr-apple-product__linked-layer mr-apple-product__linked-icon-layer';
      layer.dataset.mrLinkedIconId = position.id || ('linked-icon-' + (index + 1));
      layer.setAttribute('aria-hidden', 'true');
      layer.style.left = clamp(numberOr(position.x, 50), 0, 100) + '%';
      layer.style.top = clamp(numberOr(position.y, 68), 0, 100) + '%';
      layer.style.setProperty('--mr-layer-size', numberOr(position.size, 58) + 'px');
      layer.style.setProperty('--mr-layer-scale', 1);
      layer.style.setProperty('--mr-layer-rotation', '0deg');

      if (icon.image) {
        var img = document.createElement('img');
        img.src = icon.image;
        img.alt = '';
        layer.appendChild(img);
      } else {
        layer.textContent = icon.emoji || '\u2726';
      }

      fragment.appendChild(layer);
    });

    container.appendChild(fragment);
  }

  function updateOptionStates(elements, productData, config, state) {
    elements.section.querySelectorAll('[data-mr-product-option]').forEach(function (button) {
      var optionName = button.dataset.mrProductOption;
      var optionValue = button.dataset.mrProductValue;
      var selected = state.selectedOptions[optionName] === optionValue;
      var optionCard = button.closest('[data-mr-product-option-card]');
      var canUseCard = Boolean(optionCard && !optionCard.classList.contains('is-locked'));
      var canSelect = isFreeStepNavigation(elements)
        ? canSelectProductOptionWithAllSelections(productData, state.selectedOptions, optionName, optionValue)
        : canSelectProductOption(
          productData,
          state.selectedOptions,
          optionName,
          optionValue,
          state.frontOrder
        );
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-disabled', canUseCard && canSelect ? 'false' : 'true');
    });

    elements.section.querySelectorAll('[data-mr-font-id]').forEach(function (button) {
      var selected = button.dataset.mrFontId === state.fontId;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var selectedYarnIds = getSelectedYarnIds(state);
    elements.section.querySelectorAll('[data-mr-yarn-id]').forEach(function (button) {
      var selectedIndex = selectedYarnIds.indexOf(button.dataset.mrYarnId);
      var selected = selectedIndex !== -1;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      var badge = button.querySelector('[data-mr-yarn-order]');
      if (badge) {
        var showOrder = getYarnColorMode(config) === 'legacy' && selected;
        badge.textContent = showOrder ? String(selectedIndex + 1) : '';
        badge.hidden = !showOrder;
      }
    });

    elements.section.querySelectorAll('[data-mr-icon-id]').forEach(function (button) {
      var selected = state.icons.indexOf(button.dataset.mrIconId) !== -1;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    if (elements.nameCount) {
      elements.nameCount.textContent = state.name.length + ' / ' + stateNameLimit(elements) ;
    }
    if (elements.noNameInput) {
      elements.noNameInput.checked = Boolean(state.noName);
    }
    if (elements.nameInput) {
      elements.nameInput.disabled = Boolean(state.noName);
      elements.nameInput.setAttribute('aria-disabled', state.noName ? 'true' : 'false');
    }
  }

  function updateCards(elements, productData, config, state) {
    if (isFreeStepNavigation(elements)) {
      state.unlockedSteps = {};
      getRenderedStepCards(elements).forEach(function (card) {
        var key = card.dataset.mrCard;
        var complete = isRenderedStepComplete(card, state);
        state.unlockedSteps[key] = true;
        setCardElementLock(card, false);
        card.dataset.mrStepUnlocked = 'true';
        card.dataset.mrStepComplete = complete ? 'true' : 'false';
      });
      state.reviewUnlocked = true;
      setCardLock(elements, 'review', false);
      elements.section.dataset.mrUnlockOrder = state.frontOrder.join('|');
      elements.section.dataset.mrUnlockState = getRenderedStepCards(elements).map(function (card) {
        return card.dataset.mrCard + ':' + card.dataset.mrStepComplete + ':true';
      }).join('|');
      updateRequiredStepPresentation(elements, config, state);
      return;
    }

    var previousStepsComplete = true;
    state.unlockedSteps = {};

    getRenderedStepCards(elements).forEach(function (card) {
      var key = card.dataset.mrCard;
      var complete = isRenderedStepComplete(card, state);
      state.unlockedSteps[key] = previousStepsComplete;
      setCardElementLock(card, !previousStepsComplete);
      card.dataset.mrStepUnlocked = previousStepsComplete ? 'true' : 'false';
      card.dataset.mrStepComplete = complete ? 'true' : 'false';

      var blocksFollowingSteps = isStepRequired(config, key) && !complete;
      if (previousStepsComplete && blocksFollowingSteps) {
        previousStepsComplete = false;
      }
    });

    state.reviewUnlocked = previousStepsComplete;
    setCardLock(elements, 'review', !state.reviewUnlocked);
    elements.section.dataset.mrUnlockOrder = state.frontOrder.join('|');
    elements.section.dataset.mrUnlockState = getRenderedStepCards(elements).map(function (card) {
      return card.dataset.mrCard + ':' + card.dataset.mrStepComplete + ':' + card.dataset.mrStepUnlocked;
    }).join('|');
    updateRequiredStepPresentation(elements, config, state);
  }

  function getRenderedStepCards(elements) {
    var column = elements.section.querySelector('[data-mr-option-column]');
    if (!column) return [];
    return Array.from(column.children).filter(function (card) {
      var key = card.dataset.mrCard;
      return !card.hidden && (isOptionCardKey(key) || ['name', 'yarn', 'icons'].indexOf(key) !== -1);
    });
  }

  function isRenderedStepComplete(card, state) {
    var key = card.dataset.mrCard;
    if (isOptionCardKey(key)) {
      var optionName = card.dataset.mrProductOptionCard || getOptionNameFromCardKey(key);
      return Boolean(getSelectedOptionValue(state, optionName));
    }
    return isStepComplete(state, key);
  }

  function updateRequiredStepPresentation(elements, config, state) {
    getRenderedStepCards(elements).forEach(function (card) {
      var key = card.dataset.mrCard;
      var required = isStepRequired(config, key);
      var marker = card.querySelector('[data-mr-required-marker]');
      if (marker) marker.hidden = !required;
      card.dataset.mrRequired = required ? 'true' : 'false';

      if (isRequiredStepComplete(card, config, state)) {
        clearRequiredStepError(card);
      }
    });
  }

  function applyStepVisibility(elements, config, state) {
    var hidden = config.hiddenSteps || [];
    state.hiddenSteps = hidden;
    state.frontOrder = getFrontStepOrder(config, null, elements.section);

    elements.section.querySelectorAll('[data-mr-product-option-card]').forEach(function (card) {
      card.hidden = hidden.indexOf('size') !== -1;
    });

    ['name', 'yarn', 'icons'].forEach(function (step) {
      var card = elements.section.querySelector('[data-mr-card="' + step + '"]');
      if (!card || hidden.indexOf(step) === -1) return;
      card.hidden = true;
      if (step === 'name') state.activated.name = true;
      if (step === 'yarn') state.activated.yarn = true;
      if (step === 'icons') state.activated.icons = true;
    });
    if (hidden.indexOf('size') !== -1) state.activated.size = true;
    if (elements.optionCardsAfter) elements.optionCardsAfter.hidden = hidden.indexOf('size') !== -1;

    toggleHiddenRow(elements.section.querySelector('[data-mr-summary-size-row]'), hidden.indexOf('size') !== -1);
    toggleHiddenRow(elements.section.querySelector('[data-mr-summary-name-row]'), hidden.indexOf('name') !== -1);
    toggleHiddenRow(elements.section.querySelector('[data-mr-summary-yarn-row]'), hidden.indexOf('yarn') !== -1);
    toggleHiddenRow(elements.section.querySelector('[data-mr-summary-icons-row]'), hidden.indexOf('icons') !== -1);
  }

  function syncFrontOrderFromRenderedCards(elements, state) {
    state.frontOrder = getRenderedStepCards(elements).map(function (card) {
      return card.dataset.mrCard;
    });
  }

  function applyStepOrder(elements, config, productData) {
    var column = elements.section.querySelector('[data-mr-option-column]');
    if (!column || column.dataset.mrStepOrderApplied === 'true') return;

    var order = Array.isArray(config.step_order) ? config.step_order : [];
    var cardByName = {};
    Array.from(column.children).forEach(function (card) {
      if (!card.dataset.mrCard) return;
      cardByName[card.dataset.mrCard] = card;
    });
    var cardOrder = [];
    var optionKeys = Object.keys(cardByName).filter(isOptionCardKey);

    order.forEach(function (step) {
      var key = stepToCardKey(step);
      if (isOptionCardKey(key)) {
        key = resolveConfiguredOptionKey(
          optionKeys,
          key,
          cardOrder.filter(function (card) {
            return isOptionCardKey(card.dataset.mrCard);
          }).map(function (card) {
            return card.dataset.mrCard;
          })
        );
      }
      if (key && cardByName[key] && cardOrder.indexOf(cardByName[key]) === -1) {
        cardOrder.push(cardByName[key]);
      }
    });

    getSelectableProductOptions(productData || {}, config).forEach(function (option) {
      var key = getOptionCardKey(option.name);
      if (cardByName[key] && cardOrder.indexOf(cardByName[key]) === -1) {
        cardOrder.push(cardByName[key]);
      }
    });

    ['name', 'yarn', 'icons'].forEach(function (key) {
      if (cardByName[key] && cardOrder.indexOf(cardByName[key]) === -1) {
        cardOrder.push(cardByName[key]);
      }
    });

    cardOrder.forEach(function (card) {
      column.appendChild(card);
    });

    if (elements.optionCardsAfter) {
      var lastOptionCard = cardOrder.filter(function (card) {
        return isOptionCardKey(card.dataset.mrCard);
      }).pop();
      if (lastOptionCard) lastOptionCard.insertAdjacentElement('afterend', elements.optionCardsAfter);
    }
    if (elements.stepsBottom) column.appendChild(elements.stepsBottom);
    column.dataset.mrStepOrderApplied = 'true';
  }

  function stepToCardKey(step) {
    var value = String(step || '').trim();
    if (value.indexOf('option:') === 0) return value;
    if (value === 'name') return 'name';
    if (value === 'yarn_colors') return 'yarn';
    if (value === 'icons') return 'icons';
    return '';
  }

  function toggleHiddenRow(row, hidden) {
    if (row) row.hidden = Boolean(hidden);
  }

  function updateSummary(elements, config, state, selectedSize, selectedYarn, selectedIcons, selectedVariant, productData) {
    var optionLabel = Object.keys(state.selectedOptions || {}).length > 1
      ? 'Product Options'
      : getPrimaryOptionLabel(config, getBasketSizes(config));
    var hasSizes = getBasketSizes(config).length > 0;
    var sizeLabel = selectedSize ? (selectedSize.label || selectedSize.id) : 'Not selected';
    var nameLabel = state.noName ? 'No name requested' : (state.name.trim() || 'Not entered');
    var yarnLabel = selectedYarn ? (selectedYarn.label || selectedYarn.id) : 'Not selected';
    var iconLabel = selectedIcons.length
      ? selectedIcons.map(function (icon) { return icon.label || icon.id; }).join(', ')
      : 'None selected';

    setText(elements.reviewSizeLabel, optionLabel);
    setText(elements.reviewSize, sizeLabel);
    if (elements.reviewSize) {
      var sizeRow = elements.reviewSize.closest('.mr-apple-product__summary-row');
      if (sizeRow) sizeRow.hidden = !hasSizes || isStateStepHidden(state, 'size');
    }
    setText(elements.reviewName, nameLabel);
    setText(elements.reviewYarn, yarnLabel);
    setText(elements.reviewIcons, iconLabel);
    setText(elements.reviewTotal, formatMoney(getTotalPriceCents(selectedVariant || getDefaultVariant(productData), selectedIcons), productData.moneyFormat));

    if (elements.reviewLayout) {
      var count = selectedIcons.length + (state.noName ? 0 : 1);
      elements.reviewLayout.textContent = state.layerEditingEnabled
        ? count + ' draggable layer' + (count === 1 ? '' : 's') + ' saved automatically.'
        : count + ' design layer' + (count === 1 ? '' : 's') + ' using saved positions.';
    }

    if (elements.iconTitleText) {
      var maxIcons = positiveInteger(config.maxIcons, DEFAULT_CONFIG.maxIcons);
      elements.iconTitleText.textContent =
        'Add up to ' + maxIcons + ' icon' + (maxIcons === 1 ? '.' : 's.');
    }

    if (elements.iconLimit) {
      elements.iconLimit.textContent = selectedIcons.length + ' / ' + config.maxIcons + ' selected';
    }
  }

  function updatePrice(elements, productData, selectedVariant, selectedIcons) {
    var variant = selectedVariant || getDefaultVariant(productData);
    if (!variant) return;
    var total = getTotalPriceCents(variant, selectedIcons || []);

    (elements.prices || []).forEach(function (price) {
      price.textContent = formatMoney(total, productData.moneyFormat);
    });

    (elements.comparePrices || []).forEach(function (comparePrice) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        comparePrice.hidden = false;
        comparePrice.textContent = formatMoney(variant.compareAtPrice, productData.moneyFormat);
      } else {
        comparePrice.hidden = true;
        comparePrice.textContent = '';
      }
    });
  }

  function updateProperties(elements, productData, config, state, selectedSize, selectedYarn, selectedIcons, selectedVariant) {
    var variant = selectedVariant || null;
    var singleComponentPricing = usesSingleComponentPricing(config);
    var iconLabels = selectedIcons.map(function (icon) { return icon.label || icon.id; });
    var productionCode = buildProductionCode(config, state, selectedSize, selectedYarn, selectedIcons);
    var optionLabel = Object.keys(state.selectedOptions || {}).length > 1
      ? 'Product Options'
      : getPrimaryOptionLabel(config, getBasketSizes(config));
    var extraPrice = selectedIcons.reduce(function (sum, icon) { return sum + getIconPriceCents(icon); }, 0);
    var namePosition = !state.noName && state.layerPositions.name
      ? 'x=' + round2(state.layerPositions.name.x) + ', y=' + round2(state.layerPositions.name.y) + ', scale=' + round2(numberOr(state.layerPositions.name.scale, 1)) + ', rotation=' + round2(numberOr(state.layerPositions.name.rotation, 0))
      : '';
    var iconPositions = selectedIcons.map(function (icon, index) {
      var slotIndex = getAssignedIconSlotIndex(state, icon.id, index);
      var pos = state.layerPositions.icons && state.layerPositions.icons[icon.id]
        ? state.layerPositions.icons[icon.id]
        : getDefaultIconPosition(config, state, slotIndex);
      return (icon.label || icon.id) + ': x=' + round2(pos.x) + ', y=' + round2(pos.y) + ', scale=' + round2(numberOr(pos.scale, 1)) + ', rotation=' + round2(numberOr(pos.rotation, 0));
    }).join('; ');
    var layoutJson = JSON.stringify({
      name: state.noName ? null : (state.layerPositions.name || null),
      icons: state.layerPositions.icons || {},
      compare: state.compare
    });

    setValue(elements.variantInput, variant ? variant.id : '');
    if (elements.propertySize) elements.propertySize.name = 'properties[_' + optionLabel + ']';
    setValue(elements.propertySize, selectedSize ? (selectedSize.label || selectedSize.id) : '');
    setValue(elements.propertyName, state.noName ? 'No name requested' : (state.name || ''));
    var selectedFont = getSelectedFont(config, state);
    setValue(elements.propertyFont, !state.noName && selectedFont ? (selectedFont.label || selectedFont.id) : '');
    setValue(elements.propertyYarn, selectedYarn ? (selectedYarn.label || selectedYarn.id) : '');
    setValue(elements.propertyIcons, iconLabels.join(', '));
    setValue(elements.propertyNamePosition, namePosition);
    setValue(elements.propertyIconPositions, iconPositions);
    setValue(elements.propertyTemplate, config.template || 'basket_apple_v1');
    setValue(elements.propertyProductionCode, productionCode);
    setValue(elements.propertyConfigId, state.configId);
    setValue(elements.propertyLayoutJson, layoutJson);
    setValueByName(elements.form, 'properties[_Icon Extra Price]', extraPrice > 0 ? formatMoney(extraPrice, productData.moneyFormat) : '');
    setValueByName(elements.form, 'properties[_mamaraya_bundle_id]', state.cartBundleId || state.configId);
    setValueByName(elements.form, 'properties[_mamaraya_role]', 'parent');
    setValueByName(
      elements.form,
      'properties[_mamaraya_addon_variant_ids]',
      singleComponentPricing ? '' : buildAddonVariantIds(selectedIcons)
    );
    setValueByName(elements.form, 'properties[_mamaraya_addon_ids]', buildAddonIds(selectedIcons, singleComponentPricing));
    setValueByName(elements.form, 'properties[_mamaraya_addon_labels]', buildAddonLabels(selectedIcons, singleComponentPricing));
    setValueByName(elements.form, 'properties[_mamaraya_addon_price_cents]', buildAddonPriceCents(selectedIcons, singleComponentPricing));
    setValueByName(
      elements.form,
      'properties[_mamaraya_pricing_mode]',
      singleComponentPricing ? 'single_component_v1' : ''
    );
  }

  function updateAddButton(elements, productData, config, state) {
    var selectedIcons = getSelectedIcons(config, state);
    var freeNavigation = isFreeStepNavigation(elements);
    var variant = resolveSelectedVariant(productData, config, state);
    if (!variant && freeNavigation) {
      variant = resolvePreviewVariant(productData, state.selectedOptions, getSelectableProductOptions(productData, config));
    }
    var missingAddonVariants = usesSingleComponentPricing(config)
      ? []
      : getMissingAddonVariantIcons(selectedIcons);
    var needsConfirmation = elements.confirmPreview && elements.confirmPreview.hasAttribute('required');
    var confirmed = !needsConfirmation || (elements.confirmPreview && elements.confirmPreview.checked);
    var ready = freeNavigation
      ? Boolean(!state.isSubmitting && !missingAddonVariants.length && confirmed && (!variant || variant.available))
      : Boolean(canUseReview(state) && variant && variant.available && !missingAddonVariants.length && confirmed);

    if (!elements.addButton) return;
    elements.addButton.disabled = !ready;
    if (variant && !variant.available) {
      elements.addButton.textContent = 'Sold Out';
    } else if (state.isSubmitting) {
      elements.addButton.textContent = 'Adding...';
    } else if (missingAddonVariants.length) {
      elements.addButton.textContent = 'Add-on setup needed';
    } else {
      elements.addButton.textContent = 'Add to Cart';
    }
  }

  function bindLayerDragging(elements, config, state) {
    if (!elements.compositeStage || !elements.previewBoard) return;
    if (!state.layerEditingEnabled) return;

    var drag = null;
    var pointers = new Map();
    var dragRoot = elements.previewBoard;
    var moveThreshold = 7;

    function captureCanvasPointer(event, layer, pendingMove) {
      event.preventDefault();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      } else {
        event.stopPropagation();
      }

      if (dragRoot.setPointerCapture) dragRoot.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY,
        startX: event.clientX,
        startY: event.clientY,
        layer: layer,
        pendingMove: Boolean(pendingMove),
        moved: false
      });

      if (pointers.size >= 2) {
        layer.classList.add('is-dragging');
        pointers.forEach(function (pointer) { pointer.moved = true; });
        drag = createGestureDrag(layer, config, state, pointers);
        syncLayerSelection(elements, state);
      }
    }

    dragRoot.addEventListener('pointerdown', function (event) {
      var selectedLayer = getSelectedLayerElement(elements, state);
      var compareHandle = event.target.closest('[data-mr-compare-handle]');
      var deleteLayer = event.target.closest('[data-mr-delete-layer]');

      if (deleteLayer) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (event.pointerType === 'touch' && selectedLayer && pointers.size > 0 && !compareHandle) {
        captureCanvasPointer(event, selectedLayer, true);
        return;
      }

      var target = resolveLayerDragTarget(elements, state, event);
      var layer = target.layer;
      if (!layer) {
        if (event.pointerType === 'touch' && selectedLayer && !compareHandle) {
          captureCanvasPointer(event, selectedLayer, isMobileInteractionV2Active(elements));
          return;
        }
        if (!compareHandle) {
          clearLayerSelection(elements, state);
        }
        return;
      }

      event.preventDefault();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      } else {
        event.stopPropagation();
      }

      var handle = target.handle;
      var type = layer.dataset.mrLayer;
      var iconId = layer.dataset.mrIconId || null;
      state.selectedLayer = { type: type, id: iconId };
      layer.classList.add('is-dragging');
      dragRoot.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY,
        startX: event.clientX,
        startY: event.clientY,
        layer: layer,
        pendingMove: false,
        moved: false
      });

      if (pointers.size >= 2 && !handle) {
        drag = createGestureDrag(layer, config, state, pointers);
      } else {
        drag = createSingleDrag(layer, config, state, handle, event);
      }
      syncLayerSelection(elements, state);
    }, true);

    dragRoot.addEventListener('pointermove', function (event) {
      var tracksPointer = pointers.has(event.pointerId);
      if (tracksPointer) {
        var previous = pointers.get(event.pointerId);
        previous.x = event.clientX;
        previous.y = event.clientY;
        if (distance(previous.startX, previous.startY, event.clientX, event.clientY) >= moveThreshold) {
          previous.moved = true;
        }
      }
      if (!drag) {
        var pendingPointer = tracksPointer ? pointers.get(event.pointerId) : null;
        if (!pendingPointer) return;

        if (pointers.size >= 2) {
          pendingPointer.layer.classList.add('is-dragging');
          pointers.forEach(function (pointer) { pointer.moved = true; });
          drag = createGestureDrag(pendingPointer.layer, config, state, pointers);
        } else if (pendingPointer.pendingMove && pendingPointer.moved && isMobileInteractionV2Active(elements)) {
          pendingPointer.layer.classList.add('is-dragging');
          drag = createSingleDrag(pendingPointer.layer, config, state, null, {
            pointerId: event.pointerId,
            clientX: pendingPointer.startX,
            clientY: pendingPointer.startY
          });
        }

        if (!drag) {
          event.preventDefault();
          return;
        }
      }

      if (drag.mode !== 'gesture' && event.pointerId !== drag.pointerId) return;
      event.preventDefault();

      if (pointers.size >= 2 && drag.mode === 'move') {
        drag = createGestureDrag(drag.layer, config, state, pointers);
      }

      if (drag.mode === 'move') {
        moveLayerToPointer(elements, config, state, drag, event.clientX, event.clientY);
      } else if (drag.mode === 'resize') {
        resizeLayerFromPointer(config, state, drag, event.clientX, event.clientY);
      } else if (drag.mode === 'rotate') {
        rotateLayerFromPointer(config, state, drag, event.clientX, event.clientY);
      } else if (drag.mode === 'gesture') {
        gestureLayerFromPointers(config, state, drag, pointers);
      }

      applyDraggedLayerStyle(config, state, drag);
    });

    function endDrag(event) {
      var trackedPointer = pointers.get(event.pointerId);
      var wasPendingTap = Boolean(
        trackedPointer &&
        trackedPointer.pendingMove &&
        !trackedPointer.moved &&
        pointers.size === 1 &&
        isMobileInteractionV2Active(elements)
      );
      pointers.delete(event.pointerId);
      if (dragRoot.hasPointerCapture && dragRoot.hasPointerCapture(event.pointerId)) {
        dragRoot.releasePointerCapture(event.pointerId);
      }
      if (!drag) {
        if (trackedPointer && trackedPointer.layer) trackedPointer.layer.classList.remove('is-dragging');
        if (wasPendingTap) clearLayerSelection(elements, state);
        return;
      }
      if (drag.layer) drag.layer.classList.remove('is-dragging');
      if (pointers.size >= 2 && drag.mode === 'gesture') {
        drag = createGestureDrag(drag.layer, config, state, pointers);
        return;
      }
      drag = null;
      state.isDraggingLayer = false;
      updateAll(elements, null, config, state);
    }

    dragRoot.addEventListener('pointerup', endDrag);
    dragRoot.addEventListener('pointercancel', endDrag);

    dragRoot.addEventListener('click', function (event) {
      var deleteButton = event.target.closest('[data-mr-delete-layer]');
      if (!deleteButton) return;
      event.preventDefault();
      event.stopPropagation();
      var iconId = deleteButton.dataset.mrDeleteLayer;
      if (!iconId) return;
      toggleIcon(elements, config, state, iconId);
      state.selectedLayer = null;
      updateAll(elements, null, config, state);
    });

    elements.section.addEventListener('pointerdown', function (event) {
      if (event.target.closest('[data-mr-layer], [data-mr-transform-handle], [data-mr-compare-handle]')) return;
      clearLayerSelection(elements, state);
    });
  }

  function clearLayerSelection(elements, state) {
    if (!state.selectedLayer) return;
    state.selectedLayer = null;
    syncLayerSelection(elements, state);
  }

  function resolveLayerDragTarget(elements, state, event) {
    var target = event.target;
    var layer = target && target.closest ? target.closest('[data-mr-layer]') : null;
    if (layer && elements.compositeStage.contains(layer)) {
      return {
        layer: layer,
        handle: getTransformHandleFromTarget(target, layer)
      };
    }

    layer = findLayerAtPoint(elements, state, event.clientX, event.clientY);
    if (!layer) return { layer: null, handle: null };

    return { layer: layer, handle: null };
  }

  function getTransformHandleFromTarget(target, layer) {
    if (!target || !target.closest || !layer) return null;
    var handle = target.closest('[data-mr-transform-handle]');
    return handle && layer.contains(handle) ? handle : null;
  }

  function findLayerAtPoint(elements, state, clientX, clientY) {
    var selectedLayer = getSelectedLayerElement(elements, state);
    if (pointIsInsideElement(selectedLayer, clientX, clientY)) return selectedLayer;

    var layers = Array.from(elements.compositeStage.querySelectorAll('[data-mr-layer]')).reverse();
    for (var index = 0; index < layers.length; index += 1) {
      if (pointIsInsideElement(layers[index], clientX, clientY)) return layers[index];
    }

    return null;
  }

  function getSelectedLayerElement(elements, state) {
    if (!state.selectedLayer) return null;
    if (state.selectedLayer.type === 'icon' && state.selectedLayer.id) {
      return elements.compositeStage.querySelector('[data-mr-layer="icon"][data-mr-icon-id="' + cssEscapeAttribute(state.selectedLayer.id) + '"]');
    }
    return elements.compositeStage.querySelector('[data-mr-layer="name"]');
  }

  function pointIsInsideElement(element, clientX, clientY) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
  }

  function createSingleDrag(layer, config, state, handle, event) {
    state.isDraggingLayer = true;
    var type = layer.dataset.mrLayer;
    var iconId = layer.dataset.mrIconId || null;
    var position = getLayerPosition(config, state, type, iconId);
    var center = getLayerCenter(layer);
    var mode = handle ? handle.dataset.mrTransformHandle : 'move';
    var dragMode = 'move';
    if (mode === 'rotate') {
      dragMode = 'rotate';
    } else if (mode && mode !== 'move') {
      dragMode = 'resize';
    }

    return {
      layer: layer,
      type: type,
      iconId: iconId,
      mode: dragMode,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startLeft: numberOr(position.x, 50),
      startTop: numberOr(position.y, 50),
      center: center,
      startDistance: distance(center.x, center.y, event.clientX, event.clientY),
      startAngle: angle(center.x, center.y, event.clientX, event.clientY),
      startScale: numberOr(position.scale, 1),
      startRotation: numberOr(position.rotation, 0)
    };
  }

  function createGestureDrag(layer, config, state, pointers) {
    state.isDraggingLayer = true;
    var type = layer.dataset.mrLayer;
    var iconId = layer.dataset.mrIconId || null;
    var position = getLayerPosition(config, state, type, iconId);
    var pair = firstTwoPointers(pointers);
    return {
      layer: layer,
      type: type,
      iconId: iconId,
      mode: 'gesture',
      startDistance: distance(pair[0].x, pair[0].y, pair[1].x, pair[1].y),
      startAngle: angle(pair[0].x, pair[0].y, pair[1].x, pair[1].y),
      startScale: numberOr(position.scale, 1),
      startRotation: numberOr(position.rotation, 0)
    };
  }

  function moveLayerToPointer(elements, config, state, drag, clientX, clientY) {
    var rect = elements.compositeStage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = numberOr(drag.startLeft, 50) + ((clientX - drag.startX) / rect.width) * 100;
    var y = numberOr(drag.startTop, 50) + ((clientY - drag.startY) / rect.height) * 100;
    var safe = getPreviewForState(config, state).safeArea || { x1: 0, y1: 0, x2: 100, y2: 100 };

    x = clamp(x, numberOr(safe.x1, 0), numberOr(safe.x2, 100));
    y = clamp(y, numberOr(safe.y1, 0), numberOr(safe.y2, 100));

    var position = getLayerPosition(config, state, drag.type, drag.iconId);
    position.x = x;
    position.y = y;
    drag.layer.style.left = x + '%';
    drag.layer.style.top = y + '%';
  }

  function resizeLayerFromPointer(config, state, drag, clientX, clientY) {
    var position = getLayerPosition(config, state, drag.type, drag.iconId);
    var nextDistance = distance(drag.center.x, drag.center.y, clientX, clientY);
    var ratio = drag.startDistance > 0 ? nextDistance / drag.startDistance : 1;
    position.scale = clamp(drag.startScale * ratio, 0.35, 2.8);
  }

  function rotateLayerFromPointer(config, state, drag, clientX, clientY) {
    var position = getLayerPosition(config, state, drag.type, drag.iconId);
    var nextAngle = angle(drag.center.x, drag.center.y, clientX, clientY);
    position.rotation = drag.startRotation + (nextAngle - drag.startAngle);
  }

  function gestureLayerFromPointers(config, state, drag, pointers) {
    var pair = firstTwoPointers(pointers);
    if (pair.length < 2) return;
    var position = getLayerPosition(config, state, drag.type, drag.iconId);
    var nextDistance = distance(pair[0].x, pair[0].y, pair[1].x, pair[1].y);
    var nextAngle = angle(pair[0].x, pair[0].y, pair[1].x, pair[1].y);
    var ratio = drag.startDistance > 0 ? nextDistance / drag.startDistance : 1;
    position.scale = clamp(drag.startScale * ratio, 0.35, 2.8);
    position.rotation = drag.startRotation + (nextAngle - drag.startAngle);
  }

  function applyDraggedLayerStyle(config, state, drag) {
    if (!drag || !drag.layer) return;
    var position = getLayerPosition(config, state, drag.type, drag.iconId);
    drag.layer.style.left = clamp(position.x, 0, 100) + '%';
    drag.layer.style.top = clamp(position.y, 0, 100) + '%';
    drag.layer.style.setProperty('--mr-layer-scale', numberOr(position.scale, 1));
    drag.layer.style.setProperty('--mr-layer-rotation', numberOr(position.rotation, 0) + 'deg');
  }

  function syncLayerSelection(elements, state) {
    if (elements.previewBoard) {
      elements.previewBoard.classList.toggle('has-selected-layer', Boolean(getSelectedLayerElement(elements, state)));
    }
    elements.compositeStage.querySelectorAll('[data-mr-layer]').forEach(function (layer) {
      var type = layer.dataset.mrLayer;
      var iconId = layer.dataset.mrIconId || null;
      var selected = state.selectedLayer && state.selectedLayer.type === type && (type !== 'icon' || String(state.selectedLayer.id) === String(iconId));
      layer.classList.toggle('is-selected', selected);
      layer.querySelectorAll('[data-mr-transform-handle], [data-mr-move-surface], [data-mr-delete-layer]').forEach(function (control) {
        control.remove();
      });
      if (selected) {
        appendTransformHandles(layer, type, iconId, state);
      }
    });
  }

  function getLayerPosition(config, state, type, iconId) {
    ensureDefaultLayerPositions(config, state);
    if (type === 'icon' && iconId) {
      if (!state.layerPositions.icons) state.layerPositions.icons = {};
      if (!state.layerPositions.icons[iconId]) {
        state.layerPositions.icons[iconId] = getDefaultIconPosition(
          config,
          state,
          getAssignedIconSlotIndex(state, iconId, 0)
        );
      }
      return state.layerPositions.icons[iconId];
    }
    return state.layerPositions.name;
  }

  function getLayerCenter(layer) {
    var rect = layer.getBoundingClientRect();
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }

  function firstTwoPointers(pointers) {
    return Array.from(pointers.values()).slice(0, 2);
  }

  function distance(x1, y1, x2, y2) {
    return Math.hypot(x2 - x1, y2 - y1);
  }

  function angle(x1, y1, x2, y2) {
    return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
  }

  function bindCompareDragging(elements, state) {
    if (!elements.previewBoard || !elements.compareHandle) return;
    if (!elements.previewCard || !elements.previewCard.classList.contains('is-compare-enabled')) return;

    var compareDrag = null;

    elements.compareHandle.addEventListener('pointerdown', function (event) {
      event.preventDefault();
      state.isDraggingCompare = true;
      elements.compareHandle.setPointerCapture(event.pointerId);
      compareDrag = { pointerId: event.pointerId };
      moveCompare(elements, state, event.clientX);
    });

    elements.compareHandle.addEventListener('pointermove', function (event) {
      if (!compareDrag || event.pointerId !== compareDrag.pointerId) return;
      event.preventDefault();
      moveCompare(elements, state, event.clientX);
    });

    function endCompare(event) {
      if (!compareDrag || event.pointerId !== compareDrag.pointerId) return;
      compareDrag = null;
      state.isDraggingCompare = false;
    }

    elements.compareHandle.addEventListener('pointerup', endCompare);
    elements.compareHandle.addEventListener('pointercancel', endCompare);
  }

  function setMediaMode(elements, isMediaMode) {
    if (!elements.previewCard || !elements.previewBoard || !elements.productMediaGallery) return;

    elements.previewCard.classList.toggle('is-product-media-mode', !!isMediaMode);
    elements.previewBoard.hidden = !!isMediaMode;
    elements.productMediaGallery.hidden = !isMediaMode;

    if (elements.mediaToggle) {
      elements.mediaToggle.setAttribute('aria-pressed', isMediaMode ? 'true' : 'false');
    }

    if (elements.mediaToggleLabel) {
      elements.mediaToggleLabel.textContent = isMediaMode ? 'View Your Design' : 'Real Product Examples';
    }

    if (elements.mobileMediaToggle) {
      elements.mobileMediaToggle.setAttribute('aria-pressed', isMediaMode ? 'true' : 'false');
    }

    if (elements.mobileMediaToggleLabel) {
      elements.mobileMediaToggleLabel.textContent = isMediaMode ? 'View Your Design' : 'Real Product Examples';
    }

    if (isMediaMode && typeof window.CustomEvent === 'function') {
      elements.productMediaGallery.dispatchEvent(new CustomEvent('mr:product-media-open'));
    }
  }

  function bindMediaToggle(elements) {
    if (!elements.previewBoard || !elements.productMediaGallery || !elements.previewCard) return;

    [elements.mediaToggle, elements.mobileMediaToggle].filter(Boolean).forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isMediaMode = !elements.previewCard.classList.contains('is-product-media-mode');
        setMediaMode(elements, isMediaMode);
      });
    });
  }

  function bindMobilePreview(elements) {
    if (
      !elements.previewCard ||
      !elements.previewColumn ||
      !elements.mobilePreviewOpen ||
      !elements.mobilePreviewClose ||
      !elements.mobilePreviewFloat ||
      !elements.mobilePreviewMiniContent
    ) return;

    var isOpen = false;
    var isCollapsed = false;
    var isCompact = false;
    var compactExpanded = false;
    var mobileV2 = isMobileInteractionV2(elements);
    var autoCollapseMs = clamp(
      numberOr(elements.section.dataset.mrMobilePreviewAutoCollapseMs, 2000),
      0,
      10000
    );
    var autoCollapseTimer = null;
    var previewHeight = 0;
    var ticking = false;
    var miniRefreshQueued = false;
    var previewHome = document.createComment('MR mobile preview home');
    var previewPortal = null;
    var pageLockState = null;

    elements.previewCard.parentNode.insertBefore(previewHome, elements.previewCard);

    function getHeaderBottom() {
      var candidates = [];
      SELECTORS.stickyHeaders.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (node) {
          if (candidates.indexOf(node) === -1) candidates.push(node);
        });
      });

      var bestBottom = 0;
      var topZone = Math.min(180, window.innerHeight * 0.35);
      candidates.forEach(function (header) {
        var style = window.getComputedStyle(header);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
        if (style.position !== 'fixed' && style.position !== 'sticky') return;

        var rect = header.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= topZone || rect.height > window.innerHeight * 0.4) return;
        bestBottom = Math.max(bestBottom, Math.min(rect.bottom, window.innerHeight));
      });

      elements.section.style.setProperty('--mr-mobile-preview-top', Math.max(0, Math.round(bestBottom)) + 'px');
      return Math.max(0, bestBottom);
    }

    function refreshMiniPreview() {
      miniRefreshQueued = false;
      if (!isCollapsed || isOpen) return;

      var source = null;
      if (
        elements.previewCard.classList.contains('is-product-media-mode') &&
        elements.productMediaGallery &&
        !elements.productMediaGallery.hidden
      ) {
        source = elements.productMediaGallery;
      } else if (elements.previewBoard && !elements.previewBoard.hidden) {
        source = elements.previewBoard;
      }
      if (!source) return;

      elements.mobilePreviewFloat.classList.toggle(
        'is-compare-enabled',
        elements.previewCard.classList.contains('is-compare-enabled')
      );

      var clone = source.cloneNode(true);
      clone.removeAttribute('hidden');
      clone.querySelectorAll(
        '.mr-apple-product__product-media-thumbs, .mr-apple-product__product-media-nav, .mr-apple-product__compare-line, .mr-apple-product__compare-handle'
      ).forEach(function (node) {
        node.remove();
      });

      [clone].concat(Array.from(clone.querySelectorAll('*'))).forEach(function (node) {
        Array.from(node.attributes || []).forEach(function (attribute) {
          if (attribute.name === 'id' || attribute.name.indexOf('data-mr-') === 0) {
            node.removeAttribute(attribute.name);
          }
        });
        if (node.matches && node.matches('button, a, input, select, textarea, [tabindex]')) {
          node.setAttribute('tabindex', '-1');
        }
      });

      while (elements.mobilePreviewMiniContent.firstChild) {
        elements.mobilePreviewMiniContent.removeChild(elements.mobilePreviewMiniContent.firstChild);
      }
      elements.mobilePreviewMiniContent.appendChild(clone);
    }

    function requestMiniRefresh() {
      if (miniRefreshQueued || !isCollapsed || isOpen) return;
      miniRefreshQueued = true;
      window.requestAnimationFrame(refreshMiniPreview);
    }

    function clearAutoCollapseTimer() {
      if (!autoCollapseTimer) return;
      window.clearTimeout(autoCollapseTimer);
      autoCollapseTimer = null;
    }

    function scheduleAutoCollapse() {
      clearAutoCollapseTimer();
      if (!mobileV2 || autoCollapseMs <= 0 || !isCollapsed || isOpen) return;
      autoCollapseTimer = window.setTimeout(function () {
        autoCollapseTimer = null;
        if (isCollapsed && !isOpen) setCompact(true);
      }, autoCollapseMs);
    }

    function setCollapsed(collapsed) {
      if (isCollapsed === collapsed) return;
      isCollapsed = collapsed;
      elements.mobilePreviewFloat.hidden = !collapsed;
      elements.mobilePreviewFloat.classList.toggle('is-visible', collapsed);
      if (!collapsed) {
        clearAutoCollapseTimer();
        setCompact(false);
      }
      if (collapsed) {
        requestMiniRefresh();
        if (mobileV2) {
          setCompact(false);
          scheduleAutoCollapse();
        }
      }
    }

    function setCompact(compact) {
      if (isCompact === compact) return;
      isCompact = compact;
      elements.mobilePreviewFloat.classList.toggle('is-compact', compact);
      elements.mobilePreviewOpen.setAttribute(
        'aria-label',
        compact ? 'Show your design preview' : 'Open full design preview'
      );
    }

    function updateCollapsedState() {
      ticking = false;
      if (isOpen) return;
      if (window.innerWidth > MOBILE_MAX_WIDTH) {
        setCollapsed(false);
        return;
      }

      var previewRect = elements.previewCard.getBoundingClientRect();
      previewHeight = previewRect.height;
      if (!previewHeight) return;

      var headerBottom = getHeaderBottom();
      var obscured = Math.max(0, headerBottom - previewRect.top);
      var threshold = previewHeight * 0.9;
      var compactButtonBottom = headerBottom + 8 + 42;
      var sectionIsActive = elements.section.getBoundingClientRect().bottom > compactButtonBottom;
      var shouldShow = obscured >= threshold && sectionIsActive;
      var shouldCompact = false;

      if (mobileV2) {
        setCollapsed(shouldShow);
        return;
      }

      if (!shouldShow) compactExpanded = false;
      if (shouldShow && elements.reviewStage && !elements.reviewStage.hidden) {
        var floatBottom = headerBottom + 8 + (window.innerWidth * 0.5);
        var reviewIsNear = elements.reviewStage.getBoundingClientRect().top <= floatBottom + 16;
        if (!reviewIsNear) compactExpanded = false;
        shouldCompact = reviewIsNear && !compactExpanded;
      }

      setCollapsed(shouldShow);
      setCompact(shouldShow && shouldCompact);
    }

    function requestCollapsedUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateCollapsedState);
    }

    function lockPageScroll() {
      if (pageLockState) return;
      var body = document.body;
      var root = document.documentElement;
      pageLockState = {
        scrollY: window.scrollY || window.pageYOffset || 0,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyLeft: body.style.left,
        bodyRight: body.style.right,
        bodyWidth: body.style.width,
        bodyOverflow: body.style.overflow,
        rootOverflow: root.style.overflow
      };

      body.style.position = 'fixed';
      body.style.top = -pageLockState.scrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      root.style.overflow = 'hidden';
    }

    function unlockPageScroll() {
      if (!pageLockState) return;
      var body = document.body;
      var root = document.documentElement;
      var scrollY = pageLockState.scrollY;

      body.style.position = pageLockState.bodyPosition;
      body.style.top = pageLockState.bodyTop;
      body.style.left = pageLockState.bodyLeft;
      body.style.right = pageLockState.bodyRight;
      body.style.width = pageLockState.bodyWidth;
      body.style.overflow = pageLockState.bodyOverflow;
      root.style.overflow = pageLockState.rootOverflow;
      pageLockState = null;
      window.scrollTo(0, scrollY);
    }

    function syncPreviewPortalStyles() {
      if (!previewPortal) return;

      var computed = window.getComputedStyle(elements.section);
      var customProperties = [
        '--mr-page-bg',
        '--mr-card-bg',
        '--mr-soft-bg',
        '--mr-text',
        '--mr-muted',
        '--mr-border',
        '--mr-border-strong',
        '--mr-blue',
        '--mr-choice-selected-bg',
        '--mr-media-toggle-custom-bg',
        '--mr-media-toggle-photos-bg',
        '--mr-radius-lg',
        '--mr-radius-md',
        '--mr-max-width',
        '--mr-preview-aspect-ratio',
        '--mr-preview-sticky-gap',
        '--mr-mobile-sticky-extra',
        '--mr-title-size-desktop',
        '--mr-title-size-mobile',
        '--mr-price-size-desktop',
        '--mr-price-size-mobile',
        '--mr-mobile-step-title-size',
        '--mr-mobile-body-text-size',
        '--mr-mobile-preview-note-size',
        '--mr-name-font-family'
      ];

      previewPortal.style.cssText = elements.section.style.cssText;
      customProperties.forEach(function (name) {
        var value = computed.getPropertyValue(name).trim();
        if (value) previewPortal.style.setProperty(name, value);
      });
    }

    function mountPreviewPortal() {
      if (!previewPortal) {
        previewPortal = document.createElement('div');
        previewPortal.className = String(elements.section.className || 'mr-apple-product') + ' mr-apple-product__mobile-preview-portal';
        previewPortal.classList.add('mr-apple-product');
        previewPortal.setAttribute('role', 'dialog');
        previewPortal.setAttribute('aria-modal', 'true');
        previewPortal.setAttribute('aria-label', 'Custom preview');
      }
      syncPreviewPortalStyles();
      document.body.appendChild(previewPortal);
      previewPortal.appendChild(elements.previewCard);
    }

    function unmountPreviewPortal() {
      if (previewHome.parentNode) {
        previewHome.parentNode.insertBefore(elements.previewCard, previewHome.nextSibling);
      }
      if (previewPortal && previewPortal.parentNode) {
        previewPortal.parentNode.removeChild(previewPortal);
      }
    }

    function setOpen(open) {
      if (open) {
        clearAutoCollapseTimer();
        isOpen = true;
        lockPageScroll();
        mountPreviewPortal();
        elements.previewCard.classList.add('is-mobile-preview-open');
        elements.mobilePreviewFloat.classList.add('is-editor-open');
        elements.mobilePreviewOpen.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mr-mobile-preview-open');
        window.requestAnimationFrame(function () {
          elements.mobilePreviewClose.focus({ preventScroll: true });
        });
      } else {
        elements.previewCard.classList.remove('is-mobile-preview-open');
        unmountPreviewPortal();
        unlockPageScroll();
        isOpen = false;
        compactExpanded = false;
        elements.mobilePreviewFloat.classList.remove('is-editor-open');
        elements.mobilePreviewOpen.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mr-mobile-preview-open');
        requestMiniRefresh();
        requestCollapsedUpdate();
      }
    }

    elements.mobilePreviewOpen.addEventListener('click', function () {
      if (isCompact) {
        compactExpanded = true;
        setCompact(false);
        requestMiniRefresh();
        return;
      }
      setOpen(true);
    });

    (elements.mobilePreviewCloses || [elements.mobilePreviewClose]).forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        setOpen(false);
        elements.mobilePreviewOpen.focus({ preventScroll: true });
      });
    });

    if (elements.mobilePreviewCollapse) {
      elements.mobilePreviewCollapse.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        clearAutoCollapseTimer();
        setCompact(true);
        elements.mobilePreviewOpen.focus({ preventScroll: true });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && elements.previewCard.classList.contains('is-mobile-preview-open')) {
        setOpen(false);
        elements.mobilePreviewOpen.focus({ preventScroll: true });
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > MOBILE_MAX_WIDTH && elements.previewCard.classList.contains('is-mobile-preview-open')) {
        setOpen(false);
      }
      requestCollapsedUpdate();
    });

    window.addEventListener('scroll', function () {
      if (!mobileV2 && compactExpanded) compactExpanded = false;
      requestCollapsedUpdate();
    }, { passive: true });

    if (window.MutationObserver) {
      new MutationObserver(requestMiniRefresh).observe(elements.previewCard, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    requestCollapsedUpdate();
  }

  function bindProductMediaGallery(elements) {
    if (!elements.productMediaGallery || !elements.productMediaSlides.length) return;

    var currentIndex = 0;
    var preloadedImages = {};
    var warmupStarted = false;

    function slideImage(index) {
      var slide = elements.productMediaSlides[index];
      return slide ? slide.querySelector('img.mr-apple-product__product-media-image') : null;
    }

    function imageCacheKey(image) {
      if (!image) return '';
      return [image.currentSrc || image.src || '', image.srcset || '', image.sizes || ''].join('||');
    }

    function preloadSlideImage(index, urgent) {
      var image = slideImage(index);
      if (!image) return Promise.resolve();

      if (urgent) {
        image.loading = 'eager';
        try { image.fetchPriority = 'high'; } catch (error) {}
      }

      if (image.complete && image.naturalWidth > 0) {
        return typeof image.decode === 'function' ? image.decode().catch(function () {}) : Promise.resolve();
      }

      var key = imageCacheKey(image);
      if (!key) return Promise.resolve();
      if (preloadedImages[key]) return preloadedImages[key];

      preloadedImages[key] = new Promise(function (resolve) {
        var preloader = new Image();
        var finished = false;

        function finish() {
          if (finished) return;
          finished = true;
          if (typeof preloader.decode === 'function' && preloader.naturalWidth > 0) {
            preloader.decode().catch(function () {}).then(resolve);
          } else {
            resolve();
          }
        }

        preloader.decoding = 'async';
        try { preloader.fetchPriority = urgent ? 'high' : 'low'; } catch (error) {}
        preloader.onload = finish;
        preloader.onerror = finish;
        if (image.sizes) preloader.sizes = image.sizes;
        if (image.srcset) preloader.srcset = image.srcset;
        preloader.src = image.currentSrc || image.src;
      });

      return preloadedImages[key];
    }

    function firstImageReady() {
      var image = slideImage(0);
      if (!image || (image.complete && image.naturalWidth > 0)) return Promise.resolve();

      return new Promise(function (resolve) {
        var done = function () { resolve(); };
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', done, { once: true });
      });
    }

    function waitUntilVisible() {
      if (!document.hidden) return Promise.resolve();
      return new Promise(function (resolve) {
        document.addEventListener('visibilitychange', function onVisibilityChange() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', onVisibilityChange);
          resolve();
        });
      });
    }

    function scheduleWarmup(callback) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(callback, { timeout: 1000 });
      } else {
        window.setTimeout(callback, 180);
      }
    }

    function startSequentialWarmup() {
      if (warmupStarted) return;
      warmupStarted = true;

      firstImageReady().then(function () {
        scheduleWarmup(async function () {
          var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
          var effectiveType = String(connection && connection.effectiveType || '').toLowerCase();
          var constrained = Boolean(connection && connection.saveData)
            || effectiveType === 'slow-2g'
            || effectiveType === '2g';
          var maximumSlides = constrained
            ? Math.min(elements.productMediaSlides.length, 3)
            : elements.productMediaSlides.length;

          for (var index = 1; index < maximumSlides; index += 1) {
            await waitUntilVisible();
            await preloadSlideImage(index, false);
          }
        });
      });
    }

    function pauseInactiveMedia(activeIndex) {
      elements.productMediaSlides.forEach(function (slide, slideIndex) {
        if (slideIndex === activeIndex) return;
        slide.querySelectorAll('video').forEach(function (video) {
          if (typeof video.pause === 'function') video.pause();
        });
      });
    }

    function show(index) {
      currentIndex = (index + elements.productMediaSlides.length) % elements.productMediaSlides.length;
      var activeThumb = null;
      var targetSlide = elements.productMediaSlides[currentIndex];
      var targetImage = slideImage(currentIndex);

      if (targetImage && !(targetImage.complete && targetImage.naturalWidth > 0)) {
        targetSlide.classList.add('is-loading');
        targetImage.addEventListener('load', function () {
          targetSlide.classList.remove('is-loading');
        }, { once: true });
        targetImage.addEventListener('error', function () {
          targetSlide.classList.remove('is-loading');
        }, { once: true });
        preloadSlideImage(currentIndex, true).then(function () {
          if (targetImage.complete) targetSlide.classList.remove('is-loading');
        });
      }

      elements.productMediaSlides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      elements.productMediaThumbs.forEach(function (thumb, thumbIndex) {
        var thumbTargetIndex = Number(thumb.getAttribute('data-index') || thumbIndex);
        var active = thumbTargetIndex === currentIndex;
        thumb.classList.toggle('is-active', active);
        if (active) activeThumb = thumb;
      });

      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      pauseInactiveMedia(currentIndex);
    }

    elements.productMediaThumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        show(Number(thumb.getAttribute('data-index') || index));
      });
    });

    if (elements.productMediaPrev) {
      elements.productMediaPrev.addEventListener('click', function () {
        show(currentIndex - 1);
      });
    }

    if (elements.productMediaNext) {
      elements.productMediaNext.addEventListener('click', function () {
        show(currentIndex + 1);
      });
    }

    elements.productMediaGallery.addEventListener('mr:product-media-open', startSequentialWarmup);
    if (!elements.productMediaGallery.hidden) startSequentialWarmup();
  }

  function bindStandardProductGallery(elements) {
    if (!elements.standardMediaMain || !elements.standardMediaThumbs.length) return;

    var currentIndex = 0;
    var requestedIndex = 0;
    var preloadedImages = {};

    function preloadImage(src) {
      if (!src) return Promise.resolve('');
      if (preloadedImages[src]) return preloadedImages[src];

      preloadedImages[src] = new Promise(function (resolve) {
        var image = new Image();
        image.decoding = 'async';
        image.onload = function () {
          resolve(src);
        };
        image.onerror = function () {
          resolve(src);
        };
        image.src = src;
      });

      return preloadedImages[src];
    }

    function thumbFallback(thumb) {
      var thumbImage = thumb && thumb.querySelector('img');
      return thumbImage ? thumbImage.currentSrc || thumbImage.src || '' : '';
    }

    function warmAround(index) {
      [index - 1, index, index + 1].forEach(function (nextIndex) {
        var wrappedIndex = (nextIndex + elements.standardMediaThumbs.length) % elements.standardMediaThumbs.length;
        var image = elements.standardMediaThumbs[wrappedIndex] && elements.standardMediaThumbs[wrappedIndex].getAttribute('data-image');
        preloadImage(image);
      });
    }

    function show(index) {
      currentIndex = (index + elements.standardMediaThumbs.length) % elements.standardMediaThumbs.length;
      requestedIndex = currentIndex;
      var targetIndex = currentIndex;
      var activeThumb = elements.standardMediaThumbs[currentIndex];
      var image = activeThumb && activeThumb.getAttribute('data-image');
      var fallbackImage = thumbFallback(activeThumb);

      if (image) {
        elements.standardMediaMain.removeAttribute('srcset');
        elements.standardMediaMain.removeAttribute('sizes');
        elements.standardMediaMain.classList.add('is-loading');

        if (fallbackImage && elements.standardMediaMain.src !== fallbackImage) {
          elements.standardMediaMain.src = fallbackImage;
        }

        preloadImage(image).then(function (loadedImage) {
          if (requestedIndex !== targetIndex) return;
          elements.standardMediaMain.src = loadedImage;
          elements.standardMediaMain.classList.remove('is-loading');
        });
      }

      elements.standardMediaThumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === currentIndex);
      });

      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }

      warmAround(currentIndex);
    }

    elements.standardMediaThumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        show(index);
      });
    });

    if (elements.standardMediaPrev) {
      elements.standardMediaPrev.addEventListener('click', function () {
        show(currentIndex - 1);
      });
    }

    if (elements.standardMediaNext) {
      elements.standardMediaNext.addEventListener('click', function () {
        show(currentIndex + 1);
      });
    }

    warmAround(currentIndex);
  }

  function moveCompare(elements, state, clientX) {
    var rect = elements.previewBoard.getBoundingClientRect();
    if (!rect.width) return;
    state.compare = clamp(((clientX - rect.left) / rect.width) * 100, 5, 95);
    updateCompare(elements, state);
  }

  function getCartRenderer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getCartSectionIds(cartRenderer) {
    if (!cartRenderer || typeof cartRenderer.getSectionsToRender !== 'function') return [];
    return cartRenderer.getSectionsToRender().map(function (section) {
      return section && section.id;
    }).filter(Boolean);
  }

  function normalizeCartAddPayload(payload) {
    if (!payload || payload.key || !Array.isArray(payload.items) || !payload.items.length) return payload;
    payload.key = payload.items[0].key;
    payload.id = payload.items[0].id;
    return payload;
  }

  function closeQuickViewModal(elements) {
    var modal = elements.section && elements.section.closest('#product-modal, .product-modal');
    if (!modal) modal = document.getElementById('product-modal');
    if (!modal) return;

    modal.classList.remove('active');
    document.body.classList.remove('quickview-open');
  }

  async function submitForm(elements, productData, config, state) {
    if (state.isSubmitting) return;

    if (isFreeStepNavigation(elements)) {
      var missingRequiredCard = getFirstIncompleteRequiredCard(elements, config, state);
      if (missingRequiredCard) {
        showRequiredStepError(missingRequiredCard);
        showMessage(elements, 'Please complete the highlighted required option.', 'error');
        return;
      }
    } else if (!canUseReview(state)) {
      showMessage(elements, 'Please complete the required customization steps first.', 'error');
      return;
    }

    var needsConfirmation = elements.confirmPreview && elements.confirmPreview.hasAttribute('required');
    if (needsConfirmation && elements.confirmPreview && !elements.confirmPreview.checked) {
      if (elements.confirmError) elements.confirmError.hidden = false;
      elements.confirmPreview.focus();
      return;
    }

    var selectedSize = getSelectedSize(config, state);
    var selectedYarn = getSelectedYarn(config, state);
    var selectedIcons = getSelectedIcons(config, state);
    var selectedVariant = resolveSelectedVariant(productData, config, state);
    if (!selectedVariant && isFreeStepNavigation(elements)) {
      selectedVariant = resolvePreviewVariant(
        productData,
        state.selectedOptions,
        getSelectableProductOptions(productData, config)
      );
    }
    var missingAddonVariants = usesSingleComponentPricing(config)
      ? []
      : getMissingAddonVariantIcons(selectedIcons);

    updateProperties(elements, productData, config, state, selectedSize, selectedYarn, selectedIcons, selectedVariant);

    if (missingAddonVariants.length) {
      showMessage(
        elements,
        'One or more priced icons needs a Shopify add-on variant before checkout.',
        'error'
      );
      return;
    }

    if (!selectedVariant || !selectedVariant.id) {
      showMessage(elements, 'Unable to find a valid product variant. Please refresh and try again.', 'error');
      return;
    }

    state.isSubmitting = true;
    state.configId = createConfigId(productData.productHandle);
    state.cartBundleId = state.configId;
    updateProperties(elements, productData, config, state, selectedSize, selectedYarn, selectedIcons, selectedVariant);
    updateAddButton(elements, productData, config, state);
    hideMessage(elements);

    var properties = buildProperties(elements);
    var quantity = positiveInteger(elements.quantityInput && elements.quantityInput.value, 1);
    var item = {
      id: normalizeCartVariantId(selectedVariant.id),
      quantity: quantity,
      properties: properties
    };

    var cartRenderer = getCartRenderer();
    var cartSectionIds = getCartSectionIds(cartRenderer);

    try {
      var responseResult = await addCartItems(
        productData,
        [item],
        cartRenderer && cartSectionIds.length ? cartSectionIds : null,
        function () {
          showMessage(
            elements,
            'The cart changed while updating. Retrying…',
            'error'
          );
        }
      );
      var payload = responseResult.payload;
      if (!responseResult.ok) {
        var cartError = new Error(getCartAddErrorMessage(responseResult));
        cartError.status = responseResult.status;
        cartError.payload = payload;
        throw cartError;
      }

      if (cartRenderer && payload && payload.sections && typeof cartRenderer.renderContents === 'function') {
        normalizeCartAddPayload(payload);
        showMessage(elements, 'Added to cart.', 'success');
        closeQuickViewModal(elements);
        if (cartRenderer.classList && cartRenderer.classList.contains('is-empty')) {
          cartRenderer.classList.remove('is-empty');
        }
        cartRenderer.renderContents(payload);
        state.isSubmitting = false;
        updateAddButton(elements, productData, config, state);
        return;
      }

      showMessage(elements, 'Added to cart. Redirecting...', 'success');
      window.setTimeout(function () {
        window.location.href = productData.cartUrl || '/cart';
      }, 420);
    } catch (error) {
      showMessage(elements, error.message || 'Unable to add to cart. Please try again.', 'error');
      state.cartBundleId = '';
      state.isSubmitting = false;
      updateAddButton(elements, productData, config, state);
    }
  }

  function addCartItems(productData, items, sectionIds, onRetry) {
    var requestBody = { items: items };
    if (sectionIds && sectionIds.length) {
      requestBody.sections = sectionIds;
      requestBody.sections_url = window.location.pathname;
      var cartRenderer = getCartRenderer();
      if (cartRenderer && typeof cartRenderer.setActiveElement === 'function') {
        cartRenderer.setActiveElement(document.activeElement);
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    };
    var fetcher = function () {
      return fetch(productData.cartAddUrl || '/cart/add.js', requestOptions);
    };
    var coordinator = window.MRCartMutationCoordinator;

    if (coordinator && typeof coordinator.mutate === 'function') {
      return coordinator.mutate(fetcher, {
        maxRetries: 1,
        retryStatuses: [409],
        cooldownMs: 1200,
        onRetry: function (details) {
          if (typeof onRetry === 'function') onRetry(details.status);
        }
      }).then(function (result) {
        return {
          ok: true,
          status: result.status,
          payload: result.payload,
          response: result.response
        };
      }).catch(function (error) {
        return {
          ok: false,
          status: error.status || 0,
          payload: error.payload || null,
          error: error
        };
      });
    }

    return fetcher().then(function (response) {
      return safeJson(response).then(function (payload) {
        return {
          ok: response.ok,
          status: response.status,
          payload: payload,
          response: response
        };
      });
    });
  }

  function getCartAddErrorMessage(result) {
    var payload = result && result.payload;
    if (result && result.status === 429) {
      return 'To protect your cart from repeated automated requests, please refresh the page to verify your request, then try again.';
    }
    if (result && result.status === 409) {
      return 'The cart changed while your request was being processed. Please refresh the page and try again.';
    }
    if (payload && typeof payload === 'object') {
      return payload.description || payload.message || 'Unable to add this personalized item to cart.';
    }
    if (result && result.error && result.error.message) return result.error.message;
    return 'Unable to add this personalized item to cart.';
  }

  function buildAddonVariantIds(icons) {
    return getPricedAddonIcons(icons).map(function (icon) {
      return toProductVariantGid(icon.addonVariantId);
    }).filter(Boolean).join(',');
  }

  function buildAddonIds(icons, allowUnbound) {
    return getPricedAddonIcons(icons, allowUnbound).map(function (icon) {
      return normalizeAddonAttributePart(icon.id);
    }).join('||');
  }

  function buildAddonLabels(icons, allowUnbound) {
    return getPricedAddonIcons(icons, allowUnbound).map(function (icon) {
      return normalizeAddonAttributePart(icon.label || icon.id);
    }).join('||');
  }

  function buildAddonPriceCents(icons, allowUnbound) {
    return getPricedAddonIcons(icons, allowUnbound).map(function (icon) {
      return String(getIconPriceCents(icon));
    }).join(',');
  }

  function getPricedAddonIcons(icons, allowUnbound) {
    return (icons || []).filter(function (icon) {
      return getIconPriceCents(icon) > 0 &&
        (allowUnbound || normalizeCartVariantId(icon.addonVariantId));
    });
  }

  function usesSingleComponentPricing(config) {
    return String(
      (config && (config.addon_pricing_mode || config.addonPricingMode)) || ''
    ) === 'single_component_v1';
  }

  function toProductVariantGid(value) {
    var id = normalizeCartVariantId(value);
    return id ? 'gid://shopify/ProductVariant/' + id : '';
  }

  function normalizeAddonAttributePart(value) {
    return String(value || '').replace(/[|,]/g, ' ').trim();
  }

  function buildProperties(elements) {
    var props = {};
    if (!elements.form) return props;
    elements.form.querySelectorAll('input[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.*)\]$/);
      if (!match) return;
      if (input.value === '' && match[1].charAt(0) !== '_') return;
      props[match[1]] = input.value;
    });
    return props;
  }

  function setCardLock(elements, name, locked) {
    var card = Array.from(elements.section.querySelectorAll('[data-mr-card]')).find(function (item) {
      return item.dataset.mrCard === name;
    });
    if (!card) return;
    setCardElementLock(card, locked);
  }

  function setCardElementLock(card, locked) {
    if (!card) return;
    card.classList.toggle('is-locked', locked);
    card.setAttribute('aria-disabled', locked ? 'true' : 'false');
  }

  function isMobileInteractionV2(elements) {
    return Boolean(
      elements &&
      elements.section &&
      elements.section.dataset.mrMobileV2 === 'true'
    );
  }

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function isMobileInteractionV2Active(elements) {
    return isMobileInteractionV2(elements) && isMobileViewport();
  }

  function isLayerEditingEnabled(elements) {
    return Boolean(elements && elements.section && elements.section.dataset.mrLayerEditing === 'true');
  }

  function isFreeStepNavigation(elements) {
    if (!elements || !elements.section) return false;
    if (isMobileViewport()) {
      return Boolean(
        isMobileInteractionV2(elements) &&
        elements.section.dataset.mrEnforceStepOrderMobile !== 'true'
      );
    }
    return elements.section.dataset.mrEnforceStepOrderDesktop !== 'true';
  }

  function isStepRequired(config, step) {
    var requiredSteps = config && config.requiredSteps;
    var key = String(step || '');
    if (requiredSteps && typeof requiredSteps === 'object') {
      if (Object.prototype.hasOwnProperty.call(requiredSteps, key)) {
        return Boolean(requiredSteps[key]);
      }
      if (isOptionCardKey(key)) {
        var requestedName = normalizeComparable(getOptionNameFromCardKey(key));
        var matchingKey = Object.keys(requiredSteps).find(function (candidate) {
          return isOptionCardKey(candidate) && normalizeComparable(getOptionNameFromCardKey(candidate)) === requestedName;
        });
        if (matchingKey) return Boolean(requiredSteps[matchingKey]);
      }

      return false;
    }

    if (isOptionCardKey(key)) return true;
    if (key === 'name' || key === 'yarn') return true;
    return false;
  }

  function isRequiredStepComplete(card, config, state) {
    if (!card) return true;
    var key = card.dataset.mrCard;
    if (!isStepRequired(config, key)) return true;
    if (isOptionCardKey(key)) {
      var optionName = card.dataset.mrProductOptionCard || getOptionNameFromCardKey(key);
      return Boolean(getSelectedOptionValue(state, optionName));
    }
    if (key === 'name') return state.noName || state.name.trim().length > 0;
    if (key === 'yarn') return getSelectedYarnIds(state).length > 0;
    if (key === 'icons') return state.icons.length > 0;
    return true;
  }

  function getFirstIncompleteRequiredCard(elements, config, state) {
    return getRenderedStepCards(elements).find(function (card) {
      return !isRequiredStepComplete(card, config, state);
    }) || null;
  }

  function areRequiredStepsComplete(elements, config, state) {
    return !getFirstIncompleteRequiredCard(elements, config, state);
  }

  function clearRequiredStepError(card) {
    if (!card) return;
    card.classList.remove('has-required-error');
    var error = card.querySelector('[data-mr-required-error]');
    if (error) error.hidden = true;
  }

  function showRequiredStepError(card) {
    if (!card) return;
    var error = card.querySelector('[data-mr-required-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'mr-apple-product__required-error';
      error.dataset.mrRequiredError = '';
      error.setAttribute('role', 'alert');
      error.textContent = 'Please complete this required option.';
      card.appendChild(error);
    }
    error.hidden = false;
    card.classList.remove('has-required-error');
    void card.offsetWidth;
    card.classList.add('has-required-error');
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function canUseName(state) {
    return canUseStep(state, 'name');
  }

  function canUseYarn(state) {
    return canUseStep(state, 'yarn');
  }

  function canUseIcons(state) {
    return canUseStep(state, 'icons');
  }

  function canUseReview(state) {
    if (typeof state.reviewUnlocked === 'boolean') return state.reviewUnlocked;
    var order = state.frontOrder && state.frontOrder.length ? state.frontOrder : ['size', 'name', 'yarn', 'icons'];
    return order.every(function (step) {
      return step === 'icons' || isStepComplete(state, step);
    });
  }

  function canUseStep(state, step) {
    if (isStateStepHidden(state, step)) return false;
    if (state.unlockedSteps && Object.prototype.hasOwnProperty.call(state.unlockedSteps, step)) {
      return Boolean(state.unlockedSteps[step]);
    }

    var order = state.frontOrder && state.frontOrder.length ? state.frontOrder : ['size', 'name', 'yarn', 'icons'];
    for (var index = 0; index < order.length; index += 1) {
      var current = order[index];
      if (current === step) return true;
      if (current !== 'icons' && !isStepComplete(state, current)) return false;
    }

    return true;
  }

  function isStepComplete(state, step) {
    if (isStateStepHidden(state, step)) return true;
    if (isOptionCardKey(step)) {
      return Boolean(getSelectedOptionValue(state, getOptionNameFromCardKey(step)));
    }
    if (step === 'size') return Boolean(state.activated.size);
    if (step === 'name') return Boolean(state.noName || state.name.trim().length > 0);
    if (step === 'yarn') return Boolean(state.activated.yarn);
    if (step === 'icons') return true;
    return true;
  }

  function isStateStepHidden(state, step) {
    if (!Array.isArray(state.hiddenSteps)) return false;
    if (isOptionCardKey(step)) return state.hiddenSteps.indexOf('size') !== -1;
    return state.hiddenSteps.indexOf(step) !== -1;
  }

  function getFrontStepOrder(config, productData, section) {
    var source = Array.isArray(config && config.step_order) ? config.step_order : [];
    var hidden = Array.isArray(config && config.hiddenSteps) ? config.hiddenSteps : [];
    var optionKeys = [];
    var order = [];

    if (productData) {
      optionKeys = getSelectableProductOptions(productData, config || {}).map(function (option) {
        return getOptionCardKey(option.name);
      });
    } else if (section) {
      optionKeys = Array.from(section.querySelectorAll('[data-mr-product-option-card]')).map(function (card) {
        return card.dataset.mrCard;
      });
    }

    source.forEach(function (step) {
      var key = stepToCardKey(step);
      if (isOptionCardKey(key)) {
        key = resolveConfiguredOptionKey(
          optionKeys,
          key,
          order.filter(isOptionCardKey)
        );
      }
      if (key && order.indexOf(key) === -1) order.push(key);
    });

    optionKeys.concat(['name', 'yarn', 'icons']).forEach(function (key) {
      if (order.indexOf(key) === -1) order.push(key);
    });

    return order.filter(function (key) {
      if (isOptionCardKey(key) && hidden.indexOf('size') !== -1) return false;
      return hidden.indexOf(key) === -1;
    });
  }

  function getOptionCardKey(optionName) {
    return 'option:' + String(optionName || '').trim();
  }

  function isOptionCardKey(step) {
    return String(step || '').indexOf('option:') === 0;
  }

  function getOptionNameFromCardKey(step) {
    return isOptionCardKey(step) ? String(step).slice(7) : '';
  }

  function getSelectedOptionValue(state, optionName) {
    var selections = state && state.selectedOptions ? state.selectedOptions : {};
    if (selections[optionName]) return selections[optionName];
    var comparableName = normalizeComparable(optionName);
    var matchingName = Object.keys(selections).find(function (name) {
      return normalizeComparable(name) === comparableName;
    });
    return matchingName ? selections[matchingName] : '';
  }

  function findMatchingOptionKey(optionKeys, requestedKey) {
    var requestedName = normalizeComparable(getOptionNameFromCardKey(requestedKey));
    return (optionKeys || []).find(function (key) {
      return normalizeComparable(getOptionNameFromCardKey(key)) === requestedName;
    }) || '';
  }

  function resolveConfiguredOptionKey(optionKeys, requestedKey, usedKeys) {
    var exactMatch = findMatchingOptionKey(optionKeys, requestedKey);
    if (exactMatch) return exactMatch;
    return (optionKeys || []).find(function (key) {
      return (usedKeys || []).indexOf(key) === -1;
    }) || '';
  }

  function toggleIcon(elements, config, state, iconId) {
    var index = state.icons.indexOf(iconId);
    if (index >= 0) {
      state.icons.splice(index, 1);
      if (state.layerPositions.icons) delete state.layerPositions.icons[iconId];
      if (state.iconSlotAssignments) delete state.iconSlotAssignments[iconId];
      if (state.selectedLayer && state.selectedLayer.type === 'icon' && state.selectedLayer.id === iconId) {
        state.selectedLayer = state.layerEditingEnabled ? { type: 'name', id: null } : null;
      }
      hideMessage(elements);
      return;
    }

    if (state.icons.length >= config.maxIcons) {
      showMessage(elements, 'You can select up to ' + config.maxIcons + ' icons.', 'error');
      return;
    }

    var slotIndex = getFirstAvailableIconSlotIndex(config, state);
    state.icons.push(iconId);
    if (!state.iconSlotAssignments) state.iconSlotAssignments = {};
    state.iconSlotAssignments[iconId] = slotIndex;
    var slot = getDefaultIconPosition(config, state, slotIndex);
    if (!state.layerPositions.icons) state.layerPositions.icons = {};
    state.layerPositions.icons[iconId] = slot;
    state.selectedLayer = state.layerEditingEnabled ? { type: 'icon', id: iconId } : null;
    hideMessage(elements);
  }

  function ensureDefaultLayerPositions(config, state) {
    var preview = getPreviewForState(config, state);
    if (!state.layerPositions.name) {
      state.layerPositions.name = {
        x: numberOr(preview.name && preview.name.x, 50),
        y: numberOr(preview.name && preview.name.y, 42),
        scale: numberOr(preview.name && preview.name.scale, 1),
        rotation: numberOr(preview.name && preview.name.rotation, 0)
      };
    }
    if (!state.layerPositions.icons) state.layerPositions.icons = {};
  }

  function resetLayerPositions(config, state) {
    var preview = getPreviewForState(config, state);
    state.layerPositions = {
      name: {
        x: numberOr(preview.name && preview.name.x, 50),
        y: numberOr(preview.name && preview.name.y, 42),
        scale: numberOr(preview.name && preview.name.scale, 1),
        rotation: numberOr(preview.name && preview.name.rotation, 0)
      },
      icons: {}
    };
    state.iconSlotAssignments = {};

    state.icons.forEach(function (iconId, index) {
      state.iconSlotAssignments[iconId] = index;
      state.layerPositions.icons[iconId] = getDefaultIconPosition(config, state, index);
    });
  }

  function getAssignedIconSlotIndex(state, iconId, fallbackIndex) {
    var assigned = state.iconSlotAssignments && state.iconSlotAssignments[iconId];
    return Number.isInteger(assigned) && assigned >= 0
      ? assigned
      : Math.max(0, Math.floor(numberOr(fallbackIndex, 0)));
  }

  function getFirstAvailableIconSlotIndex(config, state) {
    var usedSlots = {};
    (state.icons || []).forEach(function (selectedIconId, index) {
      usedSlots[getAssignedIconSlotIndex(state, selectedIconId, index)] = true;
    });

    var preview = getPreviewForState(config, state);
    var configuredSlotCount = Array.isArray(preview.iconSlots) ? preview.iconSlots.length : 0;
    var searchLimit = Math.max(positiveInteger(config.maxIcons, 3), configuredSlotCount, state.icons.length + 1);
    for (var slotIndex = 0; slotIndex < searchLimit; slotIndex += 1) {
      if (!usedSlots[slotIndex]) return slotIndex;
    }
    return state.icons.length;
  }

  function getDefaultIconPosition(config, state, index) {
    var preview = getPreviewForState(config, state);
    var slots = Array.isArray(preview.iconSlots) ? preview.iconSlots : [];
    var slot = slots[index] || { x: 50, y: 68, size: 92 };
    return {
      x: numberOr(slot.x, 50),
      y: numberOr(slot.y, 68),
      size: numberOr(slot.size, 92),
      scale: numberOr(slot.scale, 1),
      rotation: numberOr(slot.rotation, 0)
    };
  }

  function normalizeConfig(rawConfig, productData) {
    var incomingConfig = adaptProductMetafieldConfig(parseMaybeString(rawConfig) || {});
    var config = deepMerge(clone(DEFAULT_CONFIG), incomingConfig);

    if (!config.preview) config.preview = { defaultCompare: 58, sizes: {} };
    if (!config.preview.sizes) config.preview.sizes = {};
    if (!config.options) config.options = {};
    if (!Array.isArray(config.options.basketSizes)) config.options.basketSizes = [];
    if (!config.groups) config.groups = { yarnColors: {}, icons: {} };
    if (!config.groups.yarnColors) config.groups.yarnColors = {};
    if (!config.groups.icons) config.groups.icons = {};

    config.nameMaxLength = positiveInteger(config.nameMaxLength, 15);
    config.maxIcons = positiveInteger(config.maxIcons, 3);
    config.maxYarnColors = clamp(
      positiveInteger(config.maxYarnColors || config.max_yarn_colors, DEFAULT_CONFIG.maxYarnColors),
      1,
      6
    );
    config.yarnColorMode = normalizeYarnColorMode(config.yarnColorMode || config.yarn_color_mode);
    config.hiddenSteps = normalizeHiddenSteps(config.hiddenSteps || config.hidden_steps || []);
    config.requiredSteps = normalizeRequiredSteps(config.requiredSteps || config.required_steps);
    config.preview.defaultCompare = clamp(numberOr(config.preview.defaultCompare, 58), 5, 95);
    config.preview.nameFontSize = positiveInteger(config.preview.nameFontSize, 76);
    config.preview.nameMaxWidth = positiveNumber(config.preview.nameMaxWidth, 58);
    config.moneyFormat = productData.moneyFormat || '${{amount}}';
    config.nameFonts = normalizeNameFonts(
      config.nameFonts,
      config.nameFontUrl,
      productData.nameFontAssetUrl
    );

    var shopifySizes = buildBasketSizesFromProduct(productData, config);
    if (shopifySizes.length && config.preferCustomBasketSizes !== true) {
      config.options.basketSizes = shopifySizes;
    } else if (!config.options.basketSizes.length) {
      config.options.basketSizes = shopifySizes;
    }

    config.options.basketSizes.forEach(function (size) {
      if (!config.preview.sizes[size.id]) {
        config.preview.sizes[size.id] = {
          realImage: null,
          cleanImage: null,
          safeArea: { x1: 0, y1: 0, x2: 100, y2: 100 },
          name: { x: 50, y: 42, fontSize: config.preview.nameFontSize, maxWidth: config.preview.nameMaxWidth },
          iconSlots: [
            { x: 38, y: 68, size: 92 },
            { x: 50, y: 68, size: 92 },
            { x: 62, y: 68, size: 92 }
          ]
        };
      }
    });

    return config;
  }

  function adaptProductMetafieldConfig(rawConfig) {
    if (!rawConfig || typeof rawConfig !== 'object') {
      return rawConfig || {};
    }

    var adapted = clone(rawConfig);
    adapted.preview = adapted.preview || {};
    adapted.preview.sizes = adapted.preview.sizes || {};
    adapted.variantPreviews = {};
    adapted.options = adapted.options || {};
    adapted.maxYarnColors = positiveInteger(
      rawConfig.max_yarn_colors || rawConfig.maxYarnColors,
      DEFAULT_CONFIG.maxYarnColors
    );
    adapted.maxIcons = positiveInteger(
      rawConfig.max_icons || rawConfig.maxIcons,
      DEFAULT_CONFIG.maxIcons
    );
    adapted.yarnColorMode = normalizeYarnColorMode(rawConfig.yarn_color_mode || rawConfig.yarnColorMode);
    adapted.requiredSteps = normalizeRequiredSteps(rawConfig.required_steps || rawConfig.requiredSteps);

    if (rawConfig.variant_configs && typeof rawConfig.variant_configs === 'object') {
      Object.keys(rawConfig.variant_configs).forEach(function (optionValue, index) {
        var source = rawConfig.variant_configs[optionValue] || {};
        var sizeId = slugify(optionValue) || ('option-' + (index + 1));
        var namePosition = source.default_name_position || {};
        var safeArea = source.safe_area || {};
        var iconPositions = Array.isArray(source.default_icon_positions)
          ? source.default_icon_positions
          : [];

        adapted.preview.sizes[sizeId] = {
          realImage: getConfiguredImage(
            source.real_image_url || source.real_image || source.real_image_gid
          ),
          cleanImage: getConfiguredImage(
            source.clean_image_url || source.clean_image || source.clean_image_gid
          ),
          safeArea: {
            x1: coordinatePercent(safeArea.left, 0),
            y1: coordinatePercent(safeArea.top, 0),
            x2: coordinatePercent(safeArea.right, 100),
            y2: coordinatePercent(safeArea.bottom, 100)
          },
          name: {
            x: coordinatePercent(namePosition.x, 50),
            y: coordinatePercent(namePosition.y, 42),
            fontSize: positiveInteger(namePosition.font_size, 76),
            maxWidth: positiveNumber(namePosition.max_width, 58),
            maxHeight: optionalPositiveNumber(namePosition.max_height)
          },
          iconSlots: iconPositions.map(function (position) {
            return {
              x: coordinatePercent(position.x, 50),
              y: coordinatePercent(position.y, 68),
              size: positiveInteger(position.size, 92)
            };
          })
        };
      });
    }

    if (rawConfig.variant_previews && typeof rawConfig.variant_previews === 'object') {
      Object.keys(rawConfig.variant_previews).forEach(function (variantId) {
        var source = rawConfig.variant_previews[variantId] || {};
        var namePosition = source.default_name_position || {};
        var safeArea = source.safe_area || {};
        var iconPositions = Array.isArray(source.default_icon_positions)
          ? source.default_icon_positions
          : [];
        var linkedNamePositions = Array.isArray(source.linked_name_positions)
          ? source.linked_name_positions
          : [];
        var linkedIconPositions = Array.isArray(source.linked_icon_positions)
          ? source.linked_icon_positions
          : [];
        adapted.variantPreviews[variantId] = {
          realImage: getConfiguredImage(source.real_image_url),
          cleanImage: getConfiguredImage(source.clean_image_url),
          safeArea: {
            x1: coordinatePercent(safeArea.left, 0),
            y1: coordinatePercent(safeArea.top, 0),
            x2: coordinatePercent(safeArea.right, 100),
            y2: coordinatePercent(safeArea.bottom, 100)
          },
          name: {
            x: coordinatePercent(namePosition.x, 50),
            y: coordinatePercent(namePosition.y, 42),
            fontSize: positiveInteger(namePosition.font_size, 76),
            maxWidth: positiveNumber(namePosition.max_width, 58),
            maxHeight: optionalPositiveNumber(namePosition.max_height)
          },
          iconSlots: iconPositions.map(function (position) {
            return {
              x: coordinatePercent(position.x, 50),
              y: coordinatePercent(position.y, 68),
              size: positiveInteger(position.size, 92)
            };
          }),
          linkedNames: linkedNamePositions.filter(function (position) {
            return position && typeof position === 'object';
          }).map(function (position, index) {
            return {
              id: String(position.id || ('linked-name-' + (index + 1))),
              x: coordinatePercent(position.x, 50),
              y: coordinatePercent(position.y, 42),
              fontSize: positiveInteger(position.font_size, 76),
              maxWidth: positiveNumber(position.max_width, 58),
              maxHeight: optionalPositiveNumber(position.max_height)
            };
          }),
          linkedIcons: linkedIconPositions.filter(function (position) {
            return position && typeof position === 'object';
          }).map(function (position, index) {
            return {
              id: String(position.id || ('linked-icon-' + (index + 1))),
              sourceIndex: nonNegativeInteger(position.source_index, 0),
              x: coordinatePercent(position.x, 50),
              y: coordinatePercent(position.y, 68),
              size: positiveInteger(position.size, 58)
            };
          })
        };
      });
    }

    if (Array.isArray(rawConfig.custom_options)) {
      rawConfig.custom_options.forEach(function (option) {
        if (!option || typeof option !== 'object') return;
        if (option.key === 'baby_name' && option.max_length) {
          adapted.nameMaxLength = option.max_length;
        }
        if (option.key === 'icons' && option.max_count) {
          adapted.maxIcons = option.max_count;
        }
      });
    }

    if (Array.isArray(rawConfig.yarn_colors)) {
      adapted.options.yarnColors = rawConfig.yarn_colors.map(function (color, index) {
        var label = String(color.label || color.name || ('Color ' + (index + 1)));
        var colors = Array.isArray(color.colors) && color.colors.length ? color.colors : null;
        var hex = String(color.hex || color.color || '#cccccc');
        var swatch = colors || (Array.isArray(color.swatch) ? color.swatch : [hex]);
        var textFill = colors || (Array.isArray(color.textFill) ? color.textFill : [hex]);
        return {
          id: String(color.id || slugify(label) || ('color-' + (index + 1))),
          label: label,
          code: normalizeCode(color.code || label),
          swatch: swatch,
          textFill: textFill,
          colors: colors || swatch,
          image: String(color.image || color.image_url || ''),
          recommended: color.recommended === true
        };
      });
    }

    if (Array.isArray(rawConfig.icons)) {
      adapted.options.icons = rawConfig.icons.map(function (icon, index) {
        var label = String(icon.label || icon.name || ('Icon ' + (index + 1)));
        var explicitCents = icon.price_cents != null ? icon.price_cents : icon.priceCents;
        return {
          id: String(icon.id || slugify(label) || ('icon-' + (index + 1))),
          label: label,
          code: normalizeCode(icon.code || label),
          image: String(icon.image || icon.image_url || ''),
          emoji: String(icon.emoji || ''),
          recommended: icon.recommended === true,
          priceCents: explicitCents != null ? Math.max(0, Math.round(Number(explicitCents) || 0)) : normalizePriceCents(icon.price_delta || icon.priceDelta || icon.price || 0),
          addonVariantId: String(icon.addon_variant_id || icon.addonVariantId || icon.variant_id || '')
        };
      });
    }

    adapted.nameFontUrl = String(
      rawConfig.name_font_url ||
      rawConfig.nameFontUrl ||
      rawConfig.font_url ||
      rawConfig.fontUrl ||
      ''
    );
    adapted.nameFonts = (Array.isArray(rawConfig.name_fonts)
      ? rawConfig.name_fonts
      : Array.isArray(rawConfig.nameFonts)
        ? rawConfig.nameFonts
        : []).map(function (font, index) {
      return {
        id: String(font.id || slugify(font.label || font.name || '') || ('font-' + (index + 1))),
        label: String(font.label || font.name || ('Font ' + (index + 1))),
        url: String(font.url || font.file_url || font.fileUrl || '')
      };
    });

    return adapted;
  }

  function addStorefrontVariantAliases(config) {
    if (!config || typeof config !== 'object') return config;
    var previews = config.variant_previews;
    if (!previews || typeof previews !== 'object' || Array.isArray(previews)) return config;
    Object.keys(previews).forEach(function (variantId) {
      var match = String(variantId).match(/^gid:\/\/shopify\/ProductVariant\/(\d+)$/);
      if (match && !Object.prototype.hasOwnProperty.call(previews, match[1])) {
        previews[match[1]] = previews[variantId];
      }
    });
    return config;
  }

  function expandStoredProductConfig(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    var wrapped = Object.prototype.hasOwnProperty.call(payload, '__mamaraya_base');
    var base = wrapped ? parseMaybeString(payload.__mamaraya_base) : payload;
    if (!base || typeof base !== 'object') return base;
    var storage = base._mamaraya_storage;
    if (!storage || Number(storage.version) !== 2) return addStorefrontVariantAliases(base);

    var chunks = wrapped && Array.isArray(payload.__mamaraya_chunks)
      ? payload.__mamaraya_chunks
      : [];
    var chunkCount = Math.max(0, Math.round(Number(storage.chunk_count) || 0));
    var merged = clone(base);
    delete merged._mamaraya_storage;
    merged.variant_previews = {};
    merged.bundle_components = {};
    merged.production_components = {};

    for (var index = 0; index < chunkCount; index += 1) {
      var chunk = parseMaybeString(chunks[index]);
      if (!chunk || typeof chunk !== 'object') {
        console.error('[MR Apple Product] Missing configuration chunk', index + 1, chunkCount);
        return null;
      }
      Object.assign(merged.variant_previews, chunk.variant_previews || {});
      Object.assign(merged.bundle_components, chunk.bundle_components || {});
      Object.assign(merged.production_components, chunk.production_components || {});
    }
    return addStorefrontVariantAliases(merged);
  }

  function normalizeNameFonts(fonts, legacyUrl, builtInUrl) {
    var used = {};
    var normalized = (Array.isArray(fonts) ? fonts : []).map(function (font, index) {
      var label = String(font.label || font.name || ('Font ' + (index + 1))).trim();
      var url = String(font.url || font.file_url || font.fileUrl || '').trim();
      var baseId = slugify(font.id || label) || ('font-' + (index + 1));
      var id = baseId;
      var suffix = 2;
      while (used[id]) {
        id = baseId + '-' + suffix;
        suffix += 1;
      }
      used[id] = true;
      return { id: id, label: label, url: url, family: '' };
    }).filter(function (font) { return font.url; });

    if (!normalized.length) {
      var fallbackUrl = String(legacyUrl || builtInUrl || '').trim();
      if (fallbackUrl) {
        normalized.push({ id: 'font-1', label: 'Default font', url: fallbackUrl, family: '' });
      }
    }
    return normalized;
  }

  function getNameFonts(config) {
    return Array.isArray(config && config.nameFonts) ? config.nameFonts : [];
  }

  function getSelectedFont(config, state) {
    var fonts = getNameFonts(config);
    return fonts.find(function (font) { return font.id === state.fontId; }) || fonts[0] || null;
  }

  function getConfiguredImage(value) {
    if (typeof value !== 'string') return null;
    var image = value.trim();
    if (!image || image.indexOf('gid://') === 0) return null;
    return image;
  }

  function coordinatePercent(value, fallback) {
    var number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    if (number >= 0 && number <= 1) number *= 100;
    return clamp(number, 0, 100);
  }

  function normalizeProductData(data) {
    data = data || {};
    if (!Array.isArray(data.variants)) data.variants = [];
    if (!Array.isArray(data.optionsWithValues)) data.optionsWithValues = [];
    return data;
  }

  function getSelectableProductOptions(productData, config) {
    if (config.use_variant_options === false) return [];
    var options = (productData.optionsWithValues || []).filter(function (option) {
      return Array.isArray(option.values) && option.values.length && !(
        normalizeComparable(option.name) === 'title' &&
        option.values.length === 1 &&
        normalizeComparable(option.values[0]) === 'default title'
      );
    });
    var order = Array.isArray(config.option_order) ? config.option_order : [];
    return options.slice().sort(function (left, right) {
      var leftIndex = order.indexOf(left.name);
      var rightIndex = order.indexOf(right.name);
      if (leftIndex < 0) leftIndex = 999;
      if (rightIndex < 0) rightIndex = 999;
      return leftIndex - rightIndex || numberOr(left.position, 0) - numberOr(right.position, 0);
    });
  }

  function variantMatchesSelections(productData, variant, selections) {
    var options = productData.optionsWithValues || [];
    return options.every(function (option, index) {
      var selected = selections[option.name];
      if (!selected) return true;
      return normalizeComparable(variant.options && variant.options[index]) === normalizeComparable(selected);
    });
  }

  function canSelectProductOption(productData, selections, optionName, optionValue, frontOrder) {
    var candidate = getRelevantSelectionsForOption(selections, optionName, frontOrder);
    candidate[optionName] = optionValue;
    return (productData.variants || []).some(function (variant) {
      return variant.available && variantMatchesSelections(productData, variant, candidate);
    });
  }

  function canSelectProductOptionWithAllSelections(productData, selections, optionName, optionValue) {
    var candidate = Object.assign({}, selections);
    delete candidate[optionName];
    candidate[optionName] = optionValue;
    return (productData.variants || []).some(function (variant) {
      return variant.available && variantMatchesSelections(productData, variant, candidate);
    });
  }

  function getRelevantSelectionsForOption(selections, optionName, frontOrder) {
    var candidate = {};
    var optionSteps = (frontOrder || []).filter(isOptionCardKey);
    var currentKey = findMatchingOptionKey(optionSteps, getOptionCardKey(optionName));
    var currentIndex = optionSteps.indexOf(currentKey);

    if (currentIndex < 0) return Object.assign({}, selections);
    optionSteps.slice(0, currentIndex).forEach(function (step) {
      var name = getOptionNameFromCardKey(step);
      if (selections[name]) candidate[name] = selections[name];
    });
    return candidate;
  }

  function resolveVariantBySelections(productData, selections, selectableOptions) {
    var options = selectableOptions || getSelectableProductOptions(productData, {});
    if (!options.length) return getDefaultVariant(productData);
    if (!options.every(function (option) { return Boolean(selections[option.name]); })) return null;
    var available = (productData.variants || []).find(function (variant) {
      return variant.available && variantMatchesSelections(productData, variant, selections);
    });
    if (available) return available;
    return (productData.variants || []).find(function (variant) {
      return variantMatchesSelections(productData, variant, selections);
    }) || null;
  }

  function resolvePreviewVariant(productData, selections, selectableOptions) {
    var options = selectableOptions || getSelectableProductOptions(productData, {});
    if (!options.length) return getDefaultVariant(productData);

    var previewSelections = Object.assign({}, selections);
    var variants = productData.variants || [];

    options.forEach(function (option) {
      if (previewSelections[option.name]) return;

      var availableValue = (option.values || []).find(function (value) {
        var candidate = Object.assign({}, previewSelections);
        candidate[option.name] = value;
        return variants.some(function (variant) {
          return variant.available && variantMatchesSelections(productData, variant, candidate);
        });
      });

      var fallbackValue = availableValue || (option.values || []).find(function (value) {
        var candidate = Object.assign({}, previewSelections);
        candidate[option.name] = value;
        return variants.some(function (variant) {
          return variantMatchesSelections(productData, variant, candidate);
        });
      });

      if (fallbackValue) previewSelections[option.name] = fallbackValue;
    });

    return resolveVariantBySelections(productData, previewSelections, options);
  }

  function reconcileOptionSelectionsAfter(productData, state, currentStep) {
    var order = Array.isArray(state.frontOrder) ? state.frontOrder : [];
    var matchedStep = findMatchingOptionKey(order.filter(isOptionCardKey), currentStep) || currentStep;
    var currentIndex = order.indexOf(matchedStep);
    if (currentIndex < 0) return;

    order.slice(currentIndex + 1).forEach(function (step) {
      if (!isOptionCardKey(step)) return;
      var optionName = getOptionNameFromCardKey(step);
      var currentValue = state.selectedOptions[optionName];
      if (!currentValue) return;

      if (canSelectProductOption(productData, state.selectedOptions, optionName, currentValue, order)) return;

      var option = (productData.optionsWithValues || []).find(function (candidate) {
        return normalizeComparable(candidate.name) === normalizeComparable(optionName);
      });
      var replacement = option && (option.values || []).find(function (value) {
        return canSelectProductOption(productData, state.selectedOptions, optionName, value, order);
      });

      if (replacement) {
        state.selectedOptions[optionName] = replacement;
      } else {
        delete state.selectedOptions[optionName];
        if (state.activated.options) state.activated.options[optionName] = false;
      }
    });
  }

  function reconcileFreeOptionSelections(productData, state, changedOptionName) {
    var selections = state.selectedOptions || {};
    var alreadyValid = (productData.variants || []).some(function (variant) {
      return variant.available && variantMatchesSelections(productData, variant, selections);
    });
    if (alreadyValid) return;

    var options = productData.optionsWithValues || [];
    var changedIndex = options.findIndex(function (option) {
      return normalizeComparable(option.name) === normalizeComparable(changedOptionName);
    });
    if (changedIndex < 0) return;

    var changedValue = selections[changedOptionName];
    var candidates = (productData.variants || []).filter(function (variant) {
      return variant.available && normalizeComparable(variant.options && variant.options[changedIndex]) === normalizeComparable(changedValue);
    });
    if (!candidates.length) return;

    candidates.sort(function (left, right) {
      var leftScore = 0;
      var rightScore = 0;
      options.forEach(function (option, index) {
        if (index === changedIndex || !selections[option.name]) return;
        if (normalizeComparable(left.options && left.options[index]) === normalizeComparable(selections[option.name])) leftScore += 1;
        if (normalizeComparable(right.options && right.options[index]) === normalizeComparable(selections[option.name])) rightScore += 1;
      });
      return rightScore - leftScore;
    });

    var best = candidates[0];
    options.forEach(function (option, index) {
      if (index === changedIndex || !selections[option.name]) return;
      selections[option.name] = best.options[index];
    });
  }

  function syncSelectedVariantState(productData, config, state) {
    var options = getSelectableProductOptions(productData, config);
    var hideAllOptions = isStateStepHidden(state, 'size');
    state.activated.options = state.activated.options || {};

    options.forEach(function (option) {
      state.activated.options[option.name] = Boolean(state.selectedOptions[option.name]);
    });

    var allSelected = options.every(function (option) {
      return Boolean(state.selectedOptions[option.name]);
    });
    var variant = null;
    if (!options.length || hideAllOptions) {
      variant = getDefaultVariant(productData);
      allSelected = true;
    } else if (allSelected) {
      variant = resolveVariantBySelections(productData, state.selectedOptions, options);
    }

    state.variantId = variant ? String(variant.id) : '';
    var previewVariant = variant || resolvePreviewVariant(productData, state.selectedOptions, options);
    state.previewVariantId = previewVariant ? String(previewVariant.id) : '';
    state.optionLabel = options.map(function (option) {
      return option.name + ': ' + (state.selectedOptions[option.name] || 'Not selected');
    }).join(' · ');
    var primaryName = (Array.isArray(config.option_order) && config.option_order[0]) || (options[0] && options[0].name);
    state.sizeId = slugify(primaryName ? state.selectedOptions[primaryName] || '' : '');
    state.activated.size = Boolean(allSelected && variant);
    return variant;
  }

  function resolveSelectedVariant(productData, config, state) {
    var options = getSelectableProductOptions(productData, config);
    if (!options.length || isStateStepHidden(state, 'size')) return getDefaultVariant(productData);
    return resolveVariantBySelections(productData, state.selectedOptions, options);
  }


  function buildBasketSizesFromProduct(productData, config) {
    productData = productData || {};
    config = config || {};

    if (config.use_variant_options === false) return [];

    var options = Array.isArray(productData.optionsWithValues) ? productData.optionsWithValues : [];
    var orderedNames = Array.isArray(config.option_order) ? config.option_order : [];
    var preferredName = orderedNames[0] || config.primary_option || '';
    var sizeOption = preferredName ? options.find(function (option) {
      return normalizeComparable(option.name) === normalizeComparable(preferredName) && Array.isArray(option.values) && option.values.length;
    }) : null;

    sizeOption = sizeOption || options.find(function (option) {
      return /size|basket/i.test(String(option.name || '')) && Array.isArray(option.values) && option.values.length;
    }) || options.find(function (option) {
      return String(option.name || '').toLowerCase() !== 'title' && Array.isArray(option.values) && option.values.length;
    });

    if (!sizeOption || !Array.isArray(sizeOption.values) || !sizeOption.values.length) return [];

    return sizeOption.values.map(function (value, index) {
      var label = String(value || '').trim();
      var id = slugify(label) || ('option-' + (index + 1));
      var available = productData.variants.some(function (variant) {
        return variant.available && Array.isArray(variant.options) && variant.options.some(function (optionValue) {
          return normalizeComparable(optionValue) === normalizeComparable(label);
        });
      });
      return {
        id: id,
        label: label,
        shortLabel: label,
        description: available ? 'Available' : 'Sold out',
        variantOptionName: sizeOption.name,
        variantOptionValue: label,
        code: normalizeCode(label)
      };
    });
  }

  function getBasketSizes(config) {
    return config.options && Array.isArray(config.options.basketSizes) ? config.options.basketSizes : [];
  }

  function getYarnColors(config) {
    var colors = [];
    if (config.options && Array.isArray(config.options.yarnColors) && config.options.yarnColors.length) {
      colors = config.options.yarnColors;
    } else {
      var group = config.yarnColorGroup || 'soft_basket';
      colors = config.groups && config.groups.yarnColors && Array.isArray(config.groups.yarnColors[group])
        ? config.groups.yarnColors[group]
        : [];
    }
    return getYarnColorMode(config) === 'legacy'
      ? flattenYarnColors(colors)
      : preserveYarnColorGroups(colors);
  }

  function preserveYarnColorGroups(colors) {
    var used = {};
    return (colors || []).map(function (color, index) {
      var list = getColorList(color);
      if (!list.length) list = ['#cccccc'];
      var label = color.label || color.name || ('Color ' + (index + 1));
      var id = uniqueYarnId(color.id || color.code || label || ('color-' + (index + 1)), used);
      return {
        id: id,
        label: label,
        code: normalizeCode(color.code || label || id),
        swatch: list,
        textFill: list,
        colors: list,
        image: color.image || color.image_url || '',
        recommended: color.recommended === true
      };
    }).filter(function (color) {
      return color.label;
    });
  }

  function flattenYarnColors(colors) {
    var used = {};
    var flattened = [];
    (colors || []).forEach(function (color, index) {
      var list = getColorList(color);
      if (!list.length) list = ['#cccccc'];

      if (list.length <= 1) {
        flattened.push(makeYarnChoice(color, index, 0, list[0], used, color.label || color.id));
        return;
      }

      var labels = splitYarnChoiceLabels(color.label || '', list.length);
      list.forEach(function (hex, itemIndex) {
        flattened.push(makeYarnChoice(
          color,
          index,
          itemIndex,
          hex,
          used,
          labels[itemIndex] || ((color.label || 'Color') + ' ' + (itemIndex + 1))
        ));
      });
    });
    return flattened;
  }

  function makeYarnChoice(color, index, itemIndex, hex, used, label) {
    var baseId = String(color.id || color.code || label || ('color-' + (index + 1)));
    var id = uniqueYarnId(itemIndex ? baseId + '-' + (itemIndex + 1) : baseId, used);
    var safeHex = hex || '#cccccc';
    return {
      id: id,
      label: label || color.label || id,
      code: normalizeCode((color.code || label || id) + (itemIndex ? '-' + (itemIndex + 1) : '')),
      swatch: [safeHex],
      textFill: [safeHex],
      colors: [safeHex],
      image: itemIndex ? '' : (color.image || ''),
      recommended: color.recommended === true
    };
  }

  function splitYarnChoiceLabels(label, count) {
    var parts = String(label || '')
      .split(/\s*(?:·|•|\||\/|\+|,|，|、)\s*/g)
      .map(function (part) { return part.trim(); })
      .filter(Boolean);
    return parts.length >= count ? parts : [];
  }

  function uniqueYarnId(input, used) {
    var base = slugify(input) || 'color';
    var next = base;
    var index = 2;
    while (used[next]) {
      next = base + '-' + index;
      index += 1;
    }
    used[next] = true;
    return next;
  }

  function getMaxYarnColors(config) {
    var max = clamp(
      positiveInteger(config.maxYarnColors || config.max_yarn_colors, DEFAULT_CONFIG.maxYarnColors),
      1,
      6
    );
    return getYarnColorMode(config) === 'legacy' ? max : 1;
  }

  function normalizeYarnColorMode(value) {
    return String(value || '').toLowerCase() === 'legacy' ? 'legacy' : 'ordered';
  }

  function getYarnColorMode(config) {
    return normalizeYarnColorMode(config.yarnColorMode || config.yarn_color_mode);
  }

  function getSelectedYarnIds(state) {
    var source = Array.isArray(state.yarnIds) && state.yarnIds.length
      ? state.yarnIds
      : (state.yarnId ? [state.yarnId] : []);
    var seen = {};
    return source.map(function (id) {
      return String(id || '');
    }).filter(function (id) {
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function setSelectedYarnIds(state, ids, max) {
    var limit = positiveInteger(max, DEFAULT_CONFIG.maxYarnColors);
    state.yarnIds = getSelectedYarnIds({ yarnIds: ids }).slice(0, limit);
    state.yarnId = state.yarnIds[0] || '';
    state.activated.yarn = state.yarnIds.length > 0;
  }

  function toggleYarnColor(elements, config, state, colorId) {
    var ids = getSelectedYarnIds(state);
    var existing = ids.indexOf(colorId);
    if (getYarnColorMode(config) !== 'legacy') {
      setSelectedYarnIds(state, existing !== -1 ? [] : [colorId], 1);
      return true;
    }

    if (existing !== -1) {
      ids.splice(existing, 1);
      setSelectedYarnIds(state, ids, getMaxYarnColors(config));
      return true;
    }

    var max = getMaxYarnColors(config);
    if (ids.length >= max) {
      showMessage(elements, 'You can select up to ' + max + ' yarn color' + (max === 1 ? '' : 's') + '.', 'error');
      return false;
    }

    ids.push(colorId);
    setSelectedYarnIds(state, ids, max);
    return true;
  }

  function getIcons(config) {
    if (config.options && Array.isArray(config.options.icons) && config.options.icons.length) {
      return config.options.icons;
    }
    var group = config.iconGroup || 'basket_icons';
    return config.groups && config.groups.icons && Array.isArray(config.groups.icons[group])
      ? config.groups.icons[group]
      : [];
  }

  function getSelectedSize(config, state) {
    if (state.variantId) {
      return {
        id: state.sizeId || state.variantId,
        label: state.optionLabel || state.variantId,
        shortLabel: state.optionLabel || state.variantId,
        variantId: state.variantId,
        code: normalizeCode(state.optionLabel || state.variantId)
      };
    }
    return getBasketSizes(config).find(function (size) { return size.id === state.sizeId; }) || null;
  }

  function getSelectedYarn(config, state) {
    var colors = getYarnColors(config);
    var ids = getSelectedYarnIds(state).slice(0, getMaxYarnColors(config));
    var selected = ids.map(function (id) {
      return colors.find(function (color) { return color.id === id; });
    }).filter(Boolean);

    if (!selected.length) return null;

    var selectedColors = [];
    if (getYarnColorMode(config) === 'legacy') {
      selectedColors = selected.map(function (color) {
        var list = getColorList(color);
        return list[0] || '#1d1d1f';
      });
    } else {
      selected.forEach(function (color) {
        var list = getColorList(color);
        if (list.length) {
          list.forEach(function (item) {
            selectedColors.push(item || '#1d1d1f');
          });
        } else {
          selectedColors.push('#1d1d1f');
        }
      });
    }
    var labels = selected.map(function (color) { return color.label || color.id; });
    var codes = selected.map(function (color) {
      return color.code || normalizeCode(color.label || color.id);
    });

    return {
      id: ids.join('__'),
      label: labels.join(' · '),
      code: codes.join('-'),
      swatch: selectedColors,
      textFill: selectedColors,
      colors: selectedColors,
      image: selected[0].image || ''
    };
  }

  function getSelectedIcons(config, state) {
    return state.icons.map(function (id) {
      return getIcons(config).find(function (icon) { return icon.id === id; });
    }).filter(Boolean);
  }

  function getPreviewForSize(config, sizeId) {
    if (sizeId && config.preview && config.preview.sizes && config.preview.sizes[sizeId]) {
      return config.preview.sizes[sizeId];
    }
    var firstSize = getBasketSizes(config)[0];
    if (firstSize && config.preview.sizes[firstSize.id]) return config.preview.sizes[firstSize.id];
    var firstConfiguredSizeId = config.preview && config.preview.sizes
      ? Object.keys(config.preview.sizes).find(function (key) { return config.preview.sizes[key]; })
      : '';
    if (firstConfiguredSizeId) return config.preview.sizes[firstConfiguredSizeId];
    return {
      realImage: null,
      cleanImage: null,
      safeArea: { x1: 0, y1: 0, x2: 100, y2: 100 },
      name: { x: 50, y: 42, fontSize: 76, maxWidth: 58 },
      iconSlots: []
    };
  }

  function getPreviewForState(config, state) {
    var previewVariantId = state.variantId || state.previewVariantId;
    if (previewVariantId) {
      var variantPreview = getVariantPreview(config, previewVariantId);
      if (variantPreview) return variantPreview;
    }

    var layoutFallback = getPreviewForSize(config, state.sizeId);
    return Object.assign({}, layoutFallback, {
      realImage: null,
      cleanImage: null
    });
  }

  function getCurrentVariantPreview(config, state) {
    return state.variantId ? getVariantPreview(config, state.variantId) : null;
  }

  function getVariantPreview(config, variantId) {
    var numericVariantId = normalizeCartVariantId(variantId);
    var previews = config && config.variantPreviews;
    if (!numericVariantId || !previews || typeof previews !== 'object') return null;

    var matchingGid = Object.keys(previews).find(function (gid) {
      return normalizeCartVariantId(gid) === numericVariantId;
    });
    return matchingGid ? previews[matchingGid] : null;
  }

  function resolveVariant(productData, selectedSize) {
    if (!selectedSize) return getDefaultVariant(productData);
    if (selectedSize.variantId) {
      return productData.variants.find(function (variant) {
        return String(variant.id) === String(selectedSize.variantId);
      }) || getDefaultVariant(productData);
    }

    var value = selectedSize.variantOptionValue || selectedSize.optionValue || selectedSize.shortLabel || selectedSize.label || selectedSize.id;
    var normalized = normalizeComparable(value);
    var availableMatch = productData.variants.find(function (variant) {
      return variant.available && Array.isArray(variant.options) && variant.options.some(function (option) {
        return normalizeComparable(option) === normalized;
      });
    });
    if (availableMatch) return availableMatch;

    var anyMatch = productData.variants.find(function (variant) {
      return Array.isArray(variant.options) && variant.options.some(function (option) {
        return normalizeComparable(option) === normalized;
      });
    });
    return anyMatch || getDefaultVariant(productData);
  }

  function isSizeAvailable(productData, size) {
    var variant = resolveVariant(productData, size);
    return variant ? Boolean(variant.available) : true;
  }

  function getDefaultVariant(productData) {
    return productData.variants.find(function (variant) {
      return String(variant.id) === String(productData.defaultVariantId);
    }) || productData.variants[0] || null;
  }

  function buildProductionCode(config, state, selectedSize, selectedYarn, selectedIcons) {
    var parts = [
      normalizeCode(config.template || 'BASKET'),
      selectedSize ? normalizeCode(selectedSize.code || selectedSize.shortLabel || selectedSize.id) : 'NOSIZE',
      selectedYarn ? normalizeCode(selectedYarn.code || selectedYarn.id) : 'NOYARN',
      !state.noName && state.name ? normalizeCode(state.name).slice(0, 12) : 'NONAME'
    ];

    if (selectedIcons.length) {
      parts.push(selectedIcons.map(function (icon) { return normalizeCode(icon.code || icon.id); }).join('-'));
    } else {
      parts.push('NOICON');
    }

    return parts.join('_');
  }

  function setupHeaderOffsetSync(section) {
    var ticking = false;

    function update() {
      ticking = false;
      var height = getVisibleStickyHeaderHeight();
      section.style.setProperty('--mr-dynamic-header-height', Math.max(0, Math.round(height)) + 'px');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
  }

  function getVisibleStickyHeaderHeight() {
    var candidates = [];
    SELECTORS.stickyHeaders.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (candidates.indexOf(node) === -1) candidates.push(node);
      });
    });

    var bestBottom = 0;
    var topZone = Math.min(180, window.innerHeight * 0.35);

    candidates.forEach(function (header) {
      if (!header) return;

      var rect = header.getBoundingClientRect();
      var style = window.getComputedStyle(header);

      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;

      var className = header.className || '';
      var isStickyLike = style.position === 'fixed'
        || style.position === 'sticky'
        || /sticky|fixed|header/i.test(String(className));

      if (!isStickyLike) return;

      var nearTop = rect.bottom > 0 && rect.top < topZone;
      if (!nearTop) return;

      bestBottom = Math.max(bestBottom, Math.min(rect.bottom, window.innerHeight));
    });

    return Math.max(0, bestBottom);
  }

  function readJson(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.warn('[MR Apple Product] Invalid JSON:', id, error);
      return null;
    }
  }

  function parseMaybeString(value) {
    if (typeof value !== 'string') return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function createNote(text) {
    var p = document.createElement('p');
    p.className = 'mr-apple-product__card-subtitle';
    p.textContent = text;
    return p;
  }

  function getSizeChartTargetOptionNames(elements, options) {
    var section = elements && elements.section;
    if (!section || section.dataset.mrHasSizeChart !== 'true') return [];

    var configuredNames = String(section.dataset.mrSizeChartOptionNames || '')
      .split(',')
      .map(function (name) { return name.trim().toLowerCase(); })
      .filter(Boolean);
    var optionNames = (Array.isArray(options) ? options : [])
      .map(function (option) { return String(option && option.name || '').trim().toLowerCase(); })
      .filter(Boolean);
    var matchedNames = optionNames.filter(function (name) {
      return configuredNames.indexOf(name) !== -1;
    });

    if (matchedNames.length) return matchedNames;
    return optionNames.length ? [optionNames[0]] : [];
  }

  function createSizeChartButton(elements, optionName, targetOptionNames) {
    var section = elements && elements.section;
    if (!section || section.dataset.mrHasSizeChart !== 'true') return null;

    var normalizedOptionName = String(optionName || '').trim().toLowerCase();
    if (!normalizedOptionName || !Array.isArray(targetOptionNames) || targetOptionNames.indexOf(normalizedOptionName) === -1) return null;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mr-apple-product__size-chart-button';
    button.setAttribute('aria-haspopup', 'dialog');

    var namespace = 'http://www.w3.org/2000/svg';
    var icon = document.createElementNS(namespace, 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    var outline = document.createElementNS(namespace, 'path');
    outline.setAttribute('d', 'M4 5.5h16v13H4zM8 5.5v4M12 5.5v2.5M16 5.5v4');
    icon.appendChild(outline);
    button.appendChild(icon);

    var label = document.createElement('span');
    label.textContent = 'Size chart';
    button.appendChild(label);

    button.addEventListener('click', function () {
      var selector = section.dataset.mrSizeChartModal;
      var modal = selector ? document.querySelector(selector) : null;
      if (modal && typeof modal.show === 'function') modal.show(button);
    });

    return button;
  }

  function createRecommendedStar() {
    var star = document.createElement('span');
    star.className = 'mr-apple-product__recommended-star';
    star.setAttribute('aria-hidden', 'true');
    var flame = createOptionValueBadgeIcon('most_popular');
    flame.classList.add('mr-apple-product__recommended-star-icon');
    star.appendChild(flame);
    return star;
  }

  function createFivePointStarSvg(className) {
    var namespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    if (className) svg.setAttribute('class', className);
    var path = document.createElementNS(namespace, 'path');
    path.setAttribute('d', 'M12 2.5l2.82 5.72 6.31.92-4.56 4.45 1.08 6.28L12 16.9l-5.65 2.97 1.08-6.28-4.56-4.45 6.31-.92L12 2.5Z');
    svg.appendChild(path);
    return svg;
  }

  function createRequiredMarker() {
    var marker = document.createElement('span');
    marker.className = 'mr-apple-product__required-marker';
    marker.dataset.mrRequiredMarker = '';
    marker.hidden = true;
    marker.setAttribute('aria-hidden', 'true');
    marker.textContent = '*';
    return marker;
  }

  function getOptionValueBadge(config, optionName, value) {
    var badgeMaps = config && (config.option_value_badges || config.optionValueBadges);
    var optionBadges = badgeMaps && badgeMaps[optionName];
    var badgeType = optionBadges && optionBadges[value];
    var legacyMatch = String(value || '').match(/\(\s*(Most Popular|Gift Pick)\s*\)\s*$/i);

    if (!badgeType && legacyMatch) {
      badgeType = legacyMatch[1].toLowerCase() === 'gift pick' ? 'gift_pick' : 'most_popular';
    }

    badgeType = String(badgeType || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (badgeType !== 'most_popular' && badgeType !== 'gift_pick') return null;

    return {
      type: badgeType,
      label: badgeType === 'gift_pick' ? 'Gift Pick' : 'Most Popular',
      legacy: Boolean(legacyMatch)
    };
  }

  function getOptionValueDisplayLabel(value, valueBadge) {
    var rawValue = String(value == null ? '' : value);
    if (!valueBadge || !valueBadge.legacy) return rawValue;
    return rawValue.replace(/\s*\(\s*(?:Most Popular|Gift Pick)\s*\)\s*$/i, '').trim() || rawValue;
  }

  function createOptionValueBadgeIcon(type) {
    var namespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');

    var shapes = type === 'gift_pick'
      ? [
        ['rect', { x: '3', y: '8', width: '18', height: '4', rx: '1' }],
        ['path', { d: 'M12 8v13' }],
        ['path', { d: 'M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7' }],
        ['path', { d: 'M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5' }]
      ]
      : [
        ['path', {
          d: 'M12 22c4.97 0 9-3.58 9-8 0-1.95-.86-3.92-2.3-5.4.1 2.4-1.4 3.3-2.2 3.4.7-4.2-2.3-8.1-6.5-10 1.8 3.1 1.3 6.4-.5 8.5-1.1-1.4-1.3-3.1-1.2-4.3C5.8 8 3 11 3 14c0 4.42 4.03 8 9 8ZM12.1 18.8c-1.5 0-2.7-1.12-2.7-2.5 0-1.05.55-1.9 1.55-3.05.08.9.4 1.58.9 2.05.62-.78.97-1.76.82-2.92 1.34.98 2.13 2.36 2.13 3.88 0 1.42-1.2 2.54-2.7 2.54Z',
          'fill-rule': 'evenodd',
          'clip-rule': 'evenodd'
        }]
      ];

    shapes.forEach(function (shape) {
      var node = document.createElementNS(namespace, shape[0]);
      Object.keys(shape[1]).forEach(function (attribute) {
        node.setAttribute(attribute, shape[1][attribute]);
      });
      svg.appendChild(node);
    });

    return svg;
  }

  function setImage(image, src) {
    if (!image) return;
    if (!src) {
      image.hidden = true;
      image.removeAttribute('src');
      return;
    }
    image.hidden = false;
    if (image.getAttribute('src') !== src) {
      image.setAttribute('src', src);
    }
  }

  function setText(node, text) {
    if (node) node.textContent = text;
  }

  function setValue(input, value) {
    if (input) input.value = value == null ? '' : String(value);
  }

  function showMessage(elements, text, type) {
    if (!elements.message) return;
    elements.message.textContent = text;
    elements.message.hidden = false;
    elements.message.classList.toggle('is-error', type === 'error');
    elements.message.classList.toggle('is-success', type === 'success');
  }

  function hideMessage(elements) {
    if (!elements.message) return;
    elements.message.hidden = true;
    elements.message.textContent = '';
    elements.message.classList.remove('is-error', 'is-success');
  }

  function injectNameFonts(config, productData, sectionId) {
    var fonts = getNameFonts(config, productData);
    var styleId = 'MRNameFonts-' + sectionId;
    var style = document.getElementById(styleId);
    if (!fonts.length) {
      if (style) style.remove();
      return;
    }

    var rules = [];
    fonts.forEach(function (font, index) {
      var familyName = [
        'MR Custom Name',
        slugify(sectionId) || 'section',
        slugify(font.id) || ('font-' + (index + 1)),
        stringFingerprint(font.url)
      ].join(' ');
      font.familyName = familyName;
      font.family = '\"' + familyName + '\",\"MR Back To School\",\"Brush Script MT\",\"Segoe Script\",cursive';
      if (font.url) {
        var sourceFormat = getFontSourceFormat(font.url);
        var formatHint = sourceFormat ? ' format(\"' + sourceFormat + '\")' : '';
        rules.push('@font-face{font-family:\"' + familyName + '\";src:url(\"' + cssEscapeUrl(font.url) + '\")' + formatHint + ';font-style:normal;font-weight:400;font-display:swap;}');
      }
    });
    if (fonts[0] && fonts[0].family) {
      rules.push('#MRAppleProduct-' + cssEscapeIdent(sectionId) + '{--mr-name-font-family:' + fonts[0].family + ';}');
    }
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = rules.join('');
    if (document.fonts && typeof document.fonts.load === 'function') {
      fonts.forEach(function (font) {
        if (!font.familyName) return;
        document.fonts.load('16px \"' + font.familyName + '\"').catch(function () {});
      });
    }
  }

  function updateStepLabels(elements) {
    var step = 1;
    elements.section.querySelectorAll('[data-mr-card]').forEach(function (card) {
      if (card.hidden || card.dataset.mrCard === 'review') return;
      var label = card.querySelector('.mr-apple-product__step-label');
      if (!label) return;
      label.textContent = 'Step ' + step;
      step += 1;
    });
  }

  function updateLayerTools(elements, state) {
    if (!elements.layerTools) return;
    if (!state.layerEditingEnabled) {
      elements.layerTools.hidden = true;
      return;
    }
    var selected = state.selectedLayer || { type: 'name', id: null };
    elements.layerTools.hidden = false;
    if (elements.layerToolsLabel) {
      elements.layerToolsLabel.textContent = selected.type === 'icon' ? 'Selected icon' : 'Selected name';
    }
  }

  function adjustSelectedLayer(elements, config, state, action) {
    if (!state.layerEditingEnabled) return;
    var selected = state.selectedLayer || { type: 'name', id: null };
    ensureDefaultLayerPositions(config, state);

    var position;
    if (selected.type === 'icon' && selected.id) {
      if (!state.layerPositions.icons) state.layerPositions.icons = {};
      position = state.layerPositions.icons[selected.id] || getDefaultIconPosition(config, state, 0);
      state.layerPositions.icons[selected.id] = position;
    } else {
      position = state.layerPositions.name;
    }

    if (!position) return;

    if (action === 'scale-up') {
      position.scale = clamp(numberOr(position.scale, 1) + 0.08, 0.45, 2.4);
    } else if (action === 'scale-down') {
      position.scale = clamp(numberOr(position.scale, 1) - 0.08, 0.45, 2.4);
    } else if (action === 'rotate-left') {
      position.rotation = numberOr(position.rotation, 0) - 6;
    } else if (action === 'rotate-right') {
      position.rotation = numberOr(position.rotation, 0) + 6;
    }
  }

  function addShowMoreButton(container, itemCount) {
    if (!container || itemCount <= CHOICE_COLLAPSE_LIMIT) return;
    container.classList.add('is-collapsed');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mr-apple-product__show-more';
    button.textContent = 'Show more';
    button.addEventListener('click', function () {
      var expanded = container.classList.toggle('is-expanded');
      container.classList.toggle('is-collapsed', !expanded);
      button.textContent = expanded ? 'Show less' : 'Show more';
    });
    container.appendChild(button);
  }

  function getPrimaryOptionLabel(config, sizes) {
    var firstSize = Array.isArray(sizes) && sizes.length ? sizes[0] : null;
    return String(
      (firstSize && firstSize.variantOptionName) ||
      config.primary_option ||
      (Array.isArray(config.option_order) && config.option_order[0]) ||
      'Product Option'
    );
  }

  function getIconPriceCents(icon) {
    if (!icon) return 0;
    if (icon.priceCents != null) return Math.max(0, Math.round(Number(icon.priceCents) || 0));
    if (icon.price_cents != null) return Math.max(0, Math.round(Number(icon.price_cents) || 0));
    return normalizePriceCents(icon.price_delta || icon.priceDelta || icon.price);
  }

  function getMissingAddonVariantIcons(icons) {
    return (icons || []).filter(function (icon) {
      return getIconPriceCents(icon) > 0 && !normalizeCartVariantId(icon.addonVariantId);
    });
  }

  function normalizeCartVariantId(value) {
    var match = String(value || '').trim().match(/(\d+)$/);
    var id = match ? Number(match[1]) : Number(value);
    return Number.isFinite(id) && id > 0 ? id : 0;
  }

  function getTotalPriceCents(variant, selectedIcons) {
    var base = normalizePriceCents(variant && variant.price);
    var extras = (selectedIcons || []).reduce(function (sum, icon) {
      return sum + getIconPriceCents(icon);
    }, 0);
    return base + extras;
  }

  function normalizePriceCents(value) {
    var number = Number(value || 0);
    if (!Number.isFinite(number) || number <= 0) return 0;
    return number > 0 && number < 100 ? Math.round(number * 100) : Math.round(number);
  }

  function setValueByName(form, name, value) {
    if (!form) return;
    var input = form.querySelector('[name="' + cssEscapeAttribute(name) + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value || '';
  }

  function cssEscapeUrl(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getFontSourceFormat(url) {
    var path = String(url || '').split(/[?#]/)[0].toLowerCase();
    if (path.endsWith('.woff2')) return 'woff2';
    if (path.endsWith('.woff')) return 'woff';
    if (path.endsWith('.otf')) return 'opentype';
    if (path.endsWith('.ttf')) return 'truetype';
    return '';
  }

  function stringFingerprint(value) {
    var text = String(value || '');
    var hash = 2166136261;
    for (var index = 0; index < text.length; index += 1) {
      hash ^= text.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  function cssEscapeIdent(value) {
    if (window.CSS && CSS.escape) return CSS.escape(String(value));
    return String(value || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function cssEscapeAttribute(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function renderNameText(layer, value, colors) {
    var palette = Array.isArray(colors) && colors.length ? colors : ['#1d1d1f'];
    var colorIndex = 0;
    layer.textContent = '';

    Array.from(String(value || '')).forEach(function (character) {
      if (/\s/.test(character)) {
        layer.appendChild(document.createTextNode(character));
        return;
      }

      var span = document.createElement('span');
      span.className = 'mr-apple-product__name-letter';
      span.style.setProperty('--mr-letter-color', palette[colorIndex % palette.length] || '#1d1d1f');
      span.textContent = character;
      layer.appendChild(span);
      colorIndex += 1;
    });
  }

  function appendTransformHandles(layer, type, id, state) {
    if (!state.layerEditingEnabled) return;
    var selected = state.selectedLayer || { type: 'name', id: null };
    var isSelected = selected.type === type && (type !== 'icon' || String(selected.id) === String(id));
    if (!isSelected) return;

    var moveSurface = document.createElement('span');
    moveSurface.className = 'mr-apple-product__move-surface';
    moveSurface.dataset.mrMoveSurface = 'true';
    moveSurface.setAttribute('aria-hidden', 'true');
    layer.appendChild(moveSurface);

    ['nw', 'ne', 'sw', 'se', 'rotate'].forEach(function (handleName) {
      var handle = document.createElement('span');
      handle.className = 'mr-apple-product__transform-handle mr-apple-product__transform-handle--' + handleName;
      handle.dataset.mrTransformHandle = handleName;
      handle.setAttribute('aria-hidden', 'true');
      layer.appendChild(handle);
    });

    if (type === 'icon' && id) {
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'mr-apple-product__layer-delete';
      remove.dataset.mrDeleteLayer = id;
      remove.setAttribute('aria-label', 'Remove selected icon');
      remove.textContent = '\u00d7';
      layer.appendChild(remove);
    }
  }

  function normalizeHiddenSteps(value) {
    var source = Array.isArray(value) ? value : String(value || '').split(',');
    var aliases = {
      variant: 'size',
      variants: 'size',
      option: 'size',
      options: 'size',
      basket: 'size',
      baby_name: 'name',
      yarn_colors: 'yarn',
      color: 'yarn',
      colors: 'yarn',
      icon: 'icons'
    };
    var allowed = ['size', 'name', 'yarn', 'icons'];
    var result = [];
    source.forEach(function (item) {
      var key = String(item || '').trim();
      if (!key) return;
      key = aliases[key] || key;
      if (allowed.indexOf(key) !== -1 && result.indexOf(key) === -1) {
        result.push(key);
      }
    });
    return result;
  }

  function normalizeRequiredSteps(value) {
    if (!value || typeof value !== 'object') return null;
    var result = {};
    var source = Array.isArray(value)
      ? value.reduce(function (steps, sourceKey) {
        steps[sourceKey] = true;
        return steps;
      }, {})
      : value;
    Object.keys(source).forEach(function (sourceKey) {
      var key = String(sourceKey || '').trim();
      if (!key) return;
      if (key === 'yarn_colors') key = 'yarn';
      if (key === 'baby_name') key = 'name';
      if (key === 'icon') key = 'icons';
      if (key === 'preview') return;
      if (!isOptionCardKey(key) && ['name', 'yarn', 'icons'].indexOf(key) === -1) return;
      result[key] = Boolean(source[sourceKey]);
    });
    return Object.keys(result).length ? result : null;
  }

  function getColorList(color) {
    if (!color) return ['#1d1d1f'];
    if (Array.isArray(color.colors) && color.colors.length) return color.colors;
    if (Array.isArray(color.textFill) && color.textFill.length) return color.textFill;
    if (Array.isArray(color.swatch) && color.swatch.length) return color.swatch;
    if (color.color) return [color.color];
    return ['#1d1d1f'];
  }

  function makeGradientOrColor(colors) {
    return colors && colors.length ? colors[0] : '#1d1d1f';
  }

  function cleanName(value, maxLength) {
    var safe = String(value || '').replace(/[\r\n\t]+/g, ' ').replace(/\s{2,}/g, ' ');
    return safe.slice(0, maxLength);
  }

  function stateNameLimit(elements) {
    return elements.nameInput ? elements.nameInput.maxLength : 15;
  }

  function normalizeComparable(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, '');
  }

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'NA';
  }

  function slugify(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function createConfigId(handle) {
    return 'MR-' + normalizeCode(handle || 'PRODUCT') + '-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
  }

  function positiveInteger(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function nonNegativeInteger(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? Math.floor(number) : fallback;
  }

  function positiveNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function optionalPositiveNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function numberOr(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function round2(value) {
    return Math.round(Number(value || 0) * 100) / 100;
  }

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function deepMerge(target, source) {
    if (!source || typeof source !== 'object') return target;
    Object.keys(source).forEach(function (key) {
      var sourceValue = source[key];
      if (Array.isArray(sourceValue)) {
        target[key] = sourceValue.slice();
      } else if (sourceValue && typeof sourceValue === 'object') {
        if (!target[key] || typeof target[key] !== 'object' || Array.isArray(target[key])) target[key] = {};
        deepMerge(target[key], sourceValue);
      } else {
        target[key] = sourceValue;
      }
    });
    return target;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = Number(cents || 0);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var moneyFormat = format || ('$' + '{' + '{amount}' + '}');

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      if (isNaN(number) || number == null) return '0';

      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = moneyFormat.match(placeholderRegex);
    if (!match) return formatWithDelimiters(value, 2);

    var replacement;
    switch (match[1]) {
      case 'amount':
        replacement = formatWithDelimiters(value, 2);
        break;
      case 'amount_no_decimals':
        replacement = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        replacement = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        replacement = formatWithDelimiters(value, 0, '.', ',');
        break;
      default:
        replacement = formatWithDelimiters(value, 2);
    }

    return stripMoneyHtml(moneyFormat.replace(placeholderRegex, replacement));
  }

  function stripMoneyHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, '');
  }

  function safeJson(response) {
    return response.text().then(function (text) {
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (error) {
        return null;
      }
    });
  }
})();
